// --- ACTIVOS v2 ---

// ── Control de Activos — usuario activo ───────────────────────────────────────
let ACTIVOS_USER = null; // null = CURRENT_USER

// ── Drilldown — referencias a datos de gráficas para onclick ─────────────────
let _drillComprasMes      = [];  // comprasMes al momento del último loadActivos
let _drillLiderUUID       = '';  // UUID del líder activo
let _drillMes             = '';  // mes activo YYYY-MM
let _drillPersonasTotales = [0, 0, 0, 0]; // total por nivel para paginación
// Paginación del drilldown Personas
let _ddPagNivel  = 0;
let _ddPagOffset = 0;
const _DD_PAGE_SIZE = 150;


const MONEDAS = {
    MEX: { simbolo: '$', codigo: 'MXN', locale: 'es-MX',  pais_nombre: 'México'      },
    USA: { simbolo: '$', codigo: 'USD', locale: 'en-US',  pais_nombre: 'EE.UU.'       },
    GTQ: { simbolo: 'Q', codigo: 'GTQ', locale: 'es-GT',  pais_nombre: 'Guatemala'    },
    CAN: { simbolo: 'C$',codigo: 'CAD', locale: 'en-CA', pais_nombre: 'Canadá'       },
    SLV: { simbolo: '$', codigo: 'USD', locale: 'es-SV',  pais_nombre: 'El Salvador'  },  // usa USD
    DEFAULT: { simbolo: '$', codigo: 'MXN', locale: 'es-MX', pais_nombre: 'Default' },
};

function _getMoneda(user) {
    return MONEDAS[user?.pais?.toUpperCase()] || MONEDAS.DEFAULT;
}

// ── Configuración de comisiones Evolution Link ─────────────────
// Carga desde BD (sistema_config) → fallback a localStorage → defaults
let COMMISSION_CONFIG = (function() {
    try {
        const saved = JSON.parse(localStorage.getItem('dulet_commission_cfg') || 'null');
        if (saved) return saved;
    } catch {}
    return {
        precio_caja: { MXN: 4500, USD: 300, GTQ: 2250, CAD: 415, SLV_USD: 300 },
        pct: { n1: 20, n2: 30, n3: 5, n4: 5 },
        umbral_empresario_led: { MXN: 10000, USD: 500, GTQ: 5000, CAD: 700, SLV_USD: 500 }
    };
})();

// ── Bootstrap de tabla sistema_config en BD ──
async function initSistemaConfig() {
    try {
        await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `CREATE TABLE IF NOT EXISTS sistema_config (
                clave TEXT PRIMARY KEY,
                valor JSONB NOT NULL DEFAULT '{}',
                updated_at TIMESTAMPTZ DEFAULT NOW(),
                updated_by TEXT
            );
            INSERT INTO sistema_config (clave, valor, updated_by)
            VALUES ('comisiones', '{"precio_caja":{"MXN":4500,"USD":300,"GTQ":2250,"CAD":415,"SLV_USD":300},"pct":{"n1":20,"n2":30,"n3":5,"n4":5},"umbral_empresario_led":{"MXN":10000,"USD":500,"GTQ":5000,"CAD":700,"SLV_USD":500}}'::jsonb, 'sistema')
            ON CONFLICT (clave) DO NOTHING;`
        });
        console.log('✅ initSistemaConfig: tabla + seed OK');
    } catch(e) { console.warn('initSistemaConfig error:', e.message); }
}

// ── Cargar configuración desde BD ──
async function loadSystemConfig() {
    try {
        const r = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: "SELECT valor FROM sistema_config WHERE clave = 'comisiones' LIMIT 1"
        });
        const row = r.rows?.[0];
        if (row && row.valor) {
            const cfg = typeof row.valor === 'string' ? JSON.parse(row.valor) : row.valor;
            if (cfg.precio_caja && cfg.pct) {
                Object.assign(COMMISSION_CONFIG, cfg);
                // Sincronizar PBOX global con el precio MXN de la config
                if (typeof window !== 'undefined') window.PBOX_OVERRIDE = cfg.precio_caja.MXN;
                // Sincronizar umbral Empresario LED (lo lee reglas_compensacion.js)
                if (cfg.umbral_empresario_led && typeof window !== 'undefined') {
                    window.UMBRAL_EMPRESARIO_LED = cfg.umbral_empresario_led;
                }
                // Backup en localStorage
                try { localStorage.setItem('dulet_commission_cfg', JSON.stringify(cfg)); } catch {}
            }
        }
        console.log('ℹ️ No hay config en BD, usando defaults/localStorage');
    } catch(e) {
        console.warn('loadSystemConfig error (usando fallback):', e.message);
    }

    // ── Cargar configuración de cierre de activos ──
    try {
        const rCierre = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: "SELECT valor FROM sistema_config WHERE clave = 'cierre_activos_config' LIMIT 1"
        });
        const rowC = rCierre.rows?.[0];
        if (rowC && rowC.valor) {
            const cfgCierre = typeof rowC.valor === 'string' ? JSON.parse(rowC.valor) : rowC.valor;
            window._cierreActivosConfig = cfgCierre;
            try { localStorage.setItem('dulet_cierre_activos_cfg', JSON.stringify(cfgCierre)); } catch {}
            console.log('✅ Cierre activos config cargada de BD:', cfgCierre);
        }
    } catch(e) {
        console.warn('loadSystemConfig cierre_activos_config error:', e.message);
    }
}

// Guardar cambios de comisión a BD + localStorage + memoria
function saveCommissionConfig(cfg) {
    Object.assign(COMMISSION_CONFIG, cfg);
    // Sincronizar PBOX
    if (cfg.precio_caja?.MXN) window.PBOX_OVERRIDE = cfg.precio_caja.MXN;
    // Backup localStorage
    try { localStorage.setItem('dulet_commission_cfg', JSON.stringify(cfg)); } catch {}
}

// Distribuir generado en por_nivel usando los % de COMMISSION_CONFIG
function _calcPorNivel(montoGenerado) {
    const p = COMMISSION_CONFIG.pct;
    const total = p.n1 + p.n2 + p.n3 + p.n4;  // 60
    if (!total || !montoGenerado) return [0, 0, 0, 0];
    return [
        Math.round(montoGenerado * p.n1 / total * 100) / 100,
        Math.round(montoGenerado * p.n2 / total * 100) / 100,
        Math.round(montoGenerado * p.n3 / total * 100) / 100,
        Math.round(montoGenerado * p.n4 / total * 100) / 100,
    ];
}

function _fmtActivo(monto, moneda) {
    return moneda.simbolo + Number(monto||0).toLocaleString(moneda.locale, {minimumFractionDigits:2, maximumFractionDigits:2}) + ' ' + moneda.codigo;
}

function resetActivosToCurrentUser() {
    ACTIVOS_USER = null;
    document.getElementById('activosBuscarId').value = '';
    loadActivos();
}

async function buscarActivosUsuario() {
    const regInput = document.getElementById('activosBuscarId')?.value?.trim();
    if (!regInput) { resetActivosToCurrentUser(); return; }
    const reg = parseInt(regInput);
    if (isNaN(reg)) { BO_AUTH.showAlert('Ingresa un # de registro numérico.', 'warning'); return; }

    // Siempre buscar en BD para asegurar el código de país actualizado
    let user = null;
    try {
        const r = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: "SELECT c.id, c.registro, c.nombre, c.ape_p AS apellido, c.email, c.galardon, COALESCE(p.codigo,'MEX') AS pais FROM cliente c LEFT JOIN pais p ON c.pais_id = p.id WHERE c.registro = " + reg + " LIMIT 1"
        });
        if (r.rows && r.rows.length) {
            const row = r.rows[0];
            user = { id: row.id, registro: row.registro, nombre: row.nombre, apellido: row.apellido || '', email: row.email || '', galardon: row.galardon || null, pais: row.pais || 'MEX' };
        }
    } catch(e) {}

    if (!user) {
        BO_AUTH.showAlert('No se encontró el líder con registro #' + reg + '.', 'warning');
        return;
    }
    ACTIVOS_USER = user;
    loadActivos();
}

// ── Activos Detalle pagination ──────────────────────────────
let _activosDet = [];   // all comprasMes rows
let _activosDetPag = 1;
var chartNiv = window.chartNiv || null;          // Chart.js instance — global
var chartCajasNiv = window.chartCajasNiv || null;     // Chart.js instance — Cajas por nivel
var chartInscritosNiv = window.chartInscritosNiv || null; // Chart.js instance — Nuevos inscritos por nivel
const _ACTIVOS_PER_PAGE = 25;

function activosDetCambiaPag(dir) {
    const total = Math.ceil(_activosDet.length / _ACTIVOS_PER_PAGE);
    _activosDetPag = Math.max(1, Math.min(total, _activosDetPag + dir));
    renderActivosDetPagina();
}

function renderActivosDetPagina() {
    const tbody  = document.getElementById('activosDetalleBody');
    const info   = document.getElementById('activosDetPagInfo');
    if (!tbody) return;
    const total   = Math.max(1, Math.ceil(_activosDet.length / _ACTIVOS_PER_PAGE));
    const inicio  = (_activosDetPag - 1) * _ACTIVOS_PER_PAGE;
    const pagina  = _activosDet.slice(inicio, inicio + _ACTIVOS_PER_PAGE);
    if (info) info.textContent = 'Pág ' + _activosDetPag + ' / ' + total + ' (' + _activosDet.length + ' compras)';

    if (!pagina.length) {
        tbody.innerHTML = '<tr><td colspan="7" style="text-align:center;color:var(--text-dim);padding:2rem;">Sin compras en este periodo.</td></tr>';
        return;
    }
    
    // Actualizar visibilidad de encabezados financieros según rol (Líderes no ven Total ni Tipo Pago)
    const thFin = document.querySelectorAll('.th-activos-financiero');
    const esLiderCheck = CURRENT_USER.rol !== 'master' && CURRENT_USER.rol !== 'admin' && CURRENT_USER.rol !== 'operativo';
    thFin.forEach(th => th.style.display = esLiderCheck ? 'none' : '');

    tbody.innerHTML = pagina.map(v => {
        const esPropia  = v._esPropia || (v.nivel === 0);
        const usaAct    = v.usaActivos && !esPropia;
        const rowBg     = esPropia ? 'rgba(34,197,94,.06)' : usaAct ? 'rgba(165,180,252,.07)' : '';
        const badge     = esPropia
            ? '<span style="color:#4ade80;font-size:.68rem;font-weight:700;margin-left:6px;padding:1px 5px;background:rgba(74,222,128,.15);border-radius:4px">✓ Compra Propia</span>'
            : usaAct
                ? '<span style="color:#a5b4fc;font-size:.68rem;font-weight:700;margin-left:6px;padding:1px 5px;background:rgba(165,180,252,.15);border-radius:4px">● Activos</span>'
                : '';
                
        const colTotal = esLiderCheck ? '' : '<td style="font-weight:700;color:var(--success)">' + v.total + '</td>';
        const colPago  = esLiderCheck ? '' : '<td><span class="pill pill-blanco" style="font-size:.68rem">' + v.tipoPago + '</span></td>';

        return '<tr style="background:' + rowBg + '">' +
            '<td style="font-weight:700;font-size:.78rem;color:var(--primary);font-family:monospace">#' + v.nota + '</td>' +
            '<td><div style="font-weight:600">' + v.cliente + badge + '</div><span style="color:var(--text-dim);font-size:.72rem">#' + v.clienteReg + '</span></td>' +
            '<td style="color:var(--text-dim);font-size:.8rem">' + v.fechaStr + '</td>' +
            colTotal +
            '<td>' + v.cajas + ' cajas</td>' +
            colPago +
            '<td>' + (v.estado === 'pendiente'
                ? '<span class="pill pill-amarillo" style="font-size:.68rem">Pendiente</span>'
                : '<span class="pill pill-blanco" style="color:var(--success);font-size:.68rem">&#10003; Aprobada</span>') + '</td>' +
            '</tr>';
    }).join('');
}

async function loadActivos() {
    const user = ACTIVOS_USER || CURRENT_USER;
    // Si el filtro de mes no tiene valor (primer load), asignar mes actual
    const mesInput = document.getElementById('mesActivosFiltro');
    if (mesInput && !mesInput.value) {
        const now = new Date();
        mesInput.value = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
    }
    const mes = mesInput?.value || new Date().toISOString().substring(0, 7);
    window._activosMesActual = mes;
    const moneda = _getMoneda(user);
    // ══ TEMP DEBUG — Diagnostic para multi-moneda ══
    console.log('🔍 [loadActivos] user.pais =', user?.pais, '| user.pais_id =', user?.pais_id, '| keys:', Object.keys(user||{}));
    console.log('🔍 [loadActivos] MONEDAS lookup:', user?.pais?.toUpperCase(), '→', MONEDAS[user?.pais?.toUpperCase()]);
    console.log('🔍 [loadActivos] moneda resolved:', moneda);
    console.log('🔍 [loadActivos] ACTIVOS_USER =', ACTIVOS_USER ? 'SET' : 'NULL', '| CURRENT_USER.pais =', CURRENT_USER?.pais);

    // Actualizar header
    const titleEl = document.getElementById('activosTitle');
    const subEl   = document.getElementById('activosSub');
    const badgeEl = document.getElementById('activosUserBadge');
    const nameEl  = document.getElementById('activosUserName');
    const idEl    = document.getElementById('activosUserId');
    const monEl   = document.getElementById('activosMonedaLabel');

    if (ACTIVOS_USER) {
        if (titleEl) titleEl.textContent = `Activos de ${user.nombre} ${user.apellido||''}`;
        if (subEl)   subEl.textContent = `${user.pais||'MEX'} • ${moneda.codigo} • ${mes}`;
        if (badgeEl) badgeEl.style.display = 'block';
        if (nameEl)  nameEl.textContent = `${user.nombre} ${user.apellido||''}`;
        if (idEl)    idEl.textContent = `#${user.registro || user.id}`;
    } else {
        if (titleEl) titleEl.textContent = 'Mis Activos';
        if (subEl)   subEl.textContent = 'Saldo y distribución por mes';
        if (badgeEl) badgeEl.style.display = 'none';
    }
    if (monEl) monEl.textContent = `${moneda.codigo} disponibles`;

    // ── Mostrar/ocultar buscador según rol ──────────────────
    const isAdminView = isAdminOrMaster();
    
    // Ocultar buscador global del Topbar en base a Rol activo (espejo o nativo)
    const topBarSearch = document.querySelector('.topbar-search');
    if (topBarSearch) {
        if (!isAdminOrMaster()) topBarSearch.style.display = 'none';
        else topBarSearch.style.display = 'block';
    }
    // Ocultar buscador de admin en vista Activos
    const buscadorAdminEl = document.getElementById('activosBuscadorAdmin');
    if (buscadorAdminEl) buscadorAdminEl.style.display = isAdminView ? 'flex' : 'none';
    // Botón "Mis Activos" solo visible si admin está viendo a otro líder
    const btnMAEl = document.getElementById('btnMisActivos');
    if (btnMAEl) btnMAEl.style.display = (isAdminView && ACTIVOS_USER) ? 'inline-flex' : 'none';

    // ── Parsear mes del filtro (formato YYYY-MM)
    const [filtroAnio, filtroMes] = mes.split('-').map(Number);
    if (typeof renderBanderinCierreActivos === 'function') await renderBanderinCierreActivos();

    // ── Resolver UUID del líder ──────────────────────────────────────────
    const liderReg = user.registro || user.id;
    let liderUUID  = (user.id && String(user.id).includes('-')) ? user.id : '';
    if (!liderUUID && liderReg) {
        try {
            const rUUID = await BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: 'SELECT id FROM cliente WHERE registro = ' + liderReg + ' LIMIT 1'
            });
            liderUUID = rUUID.rows?.[0]?.id || '';
        } catch(e) {}
    }

    // ── Consultar ventas de la red directamente desde la BD ──────────────
    // La tabla `venta` usa cliente_id (UUID). _ventasData solo tiene el mes actual.
    let comprasMes = [];
    if (liderUUID) {
        try {
            // La ventana FIFO siempre usa el mes REAL del sistema (no el filtro).
            // El query debe cubrir ambos: el filtro Y el mes real para tener todos los datos.
            const [yNum, mNum] = mes.split('-').map(Number);
            const _nowQ = new Date();
            const _mesRealQ = _nowQ.getFullYear() + '-' + String(_nowQ.getMonth() + 1).padStart(2,'0');
            // Upper bound: el mayor entre el mes del filtro y el mes real
            const mesUpper = mes > _mesRealQ ? mes : _mesRealQ;
            // Lower bound: calcular ventana histórica SSOT desde 2026-03
            const [yRealQ, mRealQ] = _mesRealQ.split('-').map(Number);
            const _numMesesHistQ = Math.max(4, (yRealQ - 2026) * 12 + (mRealQ - 3));
            const dLim = new Date(yRealQ, mRealQ - 1, 1);
            dLim.setMonth(dLim.getMonth() - _numMesesHistQ);
            const mesLimite = dLim.getFullYear() + '-' + String(dLim.getMonth() + 1).padStart(2,'0');

            // ── Subexpresión reutilizable para cajas_calc (IGUAL que QR n8n) ──
            const CAJAS_CALC_EXPR =
                "COALESCE(" +
                "  (SELECT SUM(" +
                "    CASE" +
                "      WHEN COALESCE(pr.categoria, pr2.categoria) = 'paquete' AND EXISTS (SELECT 1 FROM producto_componente pc2 WHERE pc2.paquete_id = COALESCE(pr.id, pr2.id)) THEN" +
                "        COALESCE((" +
                "          SELECT SUM(" +
                "            CASE WHEN comp_p.comisiona = true" +
                "              THEN COALESCE(comp_p.puntos_equivalencia, 1) * pc.cantidad * (pz.value->>'cantidad')::int" +
                "              ELSE 0" +
                "            END" +
                "          )" +
                "          FROM producto_componente pc" +
                "          JOIN productos comp_p ON comp_p.id = pc.componente_id" +
                "          WHERE pc.paquete_id = COALESCE(pr.id, pr2.id)" +
                "        ), 0)" +
                "      WHEN COALESCE(pr.comisiona, pr2.comisiona) = true THEN" +
                "        COALESCE(COALESCE(pr.puntos_equivalencia, pr2.puntos_equivalencia), 1) * (pz.value->>'cantidad')::int" +
                "      ELSE 0" +
                "    END" +
                "  )" +
                "  FROM jsonb_array_elements(v.piezas::jsonb) pz(value)" +
                "  LEFT JOIN productos pr ON pr.id = (pz.value->>'producto_id')::int" +
                "  LEFT JOIN productos pr2 ON pr.id IS NULL AND pr2.sku = (pz.value->>'sku') AND pr2.activo = true" +
                "  ) / 24.0," +
                "  v.cantidad" +
                ") AS cajas_calc";

            const sqlVentas =
                "WITH RECURSIVE red AS (" +
                "  SELECT id, 0 AS nivel FROM cliente WHERE id = '" + liderUUID + "'" +
                "  UNION ALL" +
                "  SELECT c.id, r.nivel + 1 FROM cliente c INNER JOIN red r ON c.patrocinador = r.id WHERE r.nivel < 4" +
                ") " +
                "(" +
                "  SELECT v.id, v.total, v.fecha_venta, v.comentario, v.approved, 0 AS nivel," +
                "         (COALESCE(c.nombre,'') || ' ' || COALESCE(c.ape_p,'')) AS cliente_nombre, c.registro AS cliente_registro, " +
                "         " + CAJAS_CALC_EXPR + " " +
                "  FROM venta v JOIN cliente c ON v.cliente_id = c.id " +
                "  WHERE v.cliente_id = '" + liderUUID + "' AND v.approved = 1 AND TO_CHAR(v.fecha_venta,'YYYY-MM') >= '" + mesLimite + "' AND TO_CHAR(v.fecha_venta,'YYYY-MM') <= '" + mesUpper + "'" +
                ") UNION ALL (" +
                "  SELECT v.id, v.total, v.fecha_venta, v.comentario, v.approved, red.nivel," +
                "         (COALESCE(c.nombre,'') || ' ' || COALESCE(c.ape_p,'')) AS cliente_nombre, c.registro AS cliente_registro, " +
                "         " + CAJAS_CALC_EXPR + " " +
                "  FROM venta v JOIN cliente c ON v.cliente_id = c.id JOIN red ON red.id = v.cliente_id " +
                "  WHERE red.nivel > 0 AND v.approved = 1 AND TO_CHAR(v.fecha_venta,'YYYY-MM') >= '" + mesLimite + "' AND TO_CHAR(v.fecha_venta,'YYYY-MM') <= '" + mesUpper + "'" +
                "  ORDER BY v.fecha_venta DESC LIMIT 10000" +
                ")";
            const rVentas = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlVentas });

            comprasMes = (rVentas.rows || []).map(v => {
                let total = parseFloat(v.total || 0);
                const cajas = parseFloat(v.cajas_calc) || 0;
                const fechaD = v.fecha_venta ? new Date(String(v.fecha_venta).substring(0,10) + 'T12:00:00') : null;
                const nivel  = parseInt(v.nivel ?? 0);
                return {
                    nota:       String(v.id || '').substring(0, 8).toUpperCase() || '???',
                    notaFull:   v.id || '',
                    cliente:    (v.cliente_nombre || 'Desconocido').trim(),
                    clienteReg: v.cliente_registro || '—',
                    cliente_id: v.cliente_id || v.usuario_id,
                    fechaD,
                    fechaStr:   fechaD ? fechaD.toLocaleDateString('es-MX',{day:'2-digit',month:'2-digit',year:'numeric'}) : '—',
                    mesStr:     fechaD ? fechaD.getFullYear() + '-' + String(fechaD.getMonth() + 1).padStart(2, '0') : '—',
                    mes:        fechaD ? fechaD.getMonth() + 1 : 0,
                    anio:       fechaD ? fechaD.getFullYear() : 0,
                    total:      '$' + total.toLocaleString('es-MX',{minimumFractionDigits:2}),
                    totalNum:   total,
                    tipoPago:   parseVentasPago(v.comentario),
                    estado:     parseInt(v.approved) === 1 ? 'aprobada' : 'pendiente',
                    cajas,
                    nivel          // nivel en la cadena: 0=líder, 1=N1, 2=N2, 3=N3, 4=N4
                };
            });
            // Asignamos solo las de este mes a la tabla visual
            window._comprasHistoricas = comprasMes;
            comprasMes = comprasMes.filter(v => v.mesStr === mes);
            
        } catch(e) { console.warn('BD ventas query error:', e.message); }
    } else {
        // Fallback: filtrar _ventasData por mes
        if (!_ventasData || !_ventasData.length) { try { await loadVentasHistorial(); } catch(e) {} }
        window._comprasHistoricas = _ventasData || [];
        comprasMes = (_ventasData || []).filter(v => v.mesStr === mes);
    }

    // ── Monto generado (recolectar cajas para Motor de Reglas) ────────────
    const _precioCaja = COMMISSION_CONFIG.precio_caja[moneda.codigo] || 4500;
    const cajasEnv = { n1: 0, n2: 0, n3: 0, n4: 0 };
    comprasMes.forEach(v => {
        const n = Math.max(0, Math.min(4, v.nivel ?? 1));
        if (n > 0) cajasEnv['n' + n] += (v.cajas || 0);
    });

    // ── Activos USADOS e INYECTADOS HISTORICAMENTE (Para el Ledger FIFO) ─────────────
    let montoGastadoHistorico = 0;
    window.ACTIVOS_CREDITO_AJUSTE = 0;
    // Construir ventana FIFO: M-4 a M-1 del MES REAL (no del filtro)
    const _nowFifo = new Date();
    const _aNum = _nowFifo.getFullYear();
    const _mNum = _nowFifo.getMonth() + 1;
    const _fifoMeses = [];
    const _fifoActive = []; // Solo meses no-expirados (edadMeses < 4)
    for (let _i = 4; _i >= 1; _i--) {
        const _d = new Date(_aNum, _mNum - 1 - _i, 1);
        const _mStr = _d.getFullYear() + '-' + String(_d.getMonth()+1).padStart(2,'0');
        _fifoMeses.push(_mStr);
        if (_i <= 3) _fifoActive.push(_mStr); // M-3, M-2, M-1 = no expirados
    }
    const _fifoIn = _fifoMeses.map(m => "'" + m + "'").join(',');
    const _fifoActiveIn = _fifoActive.map(m => "'" + m + "'").join(',');
    try {
        // gastado = SOLO débitos reales (pagos con activos). Los credito_ajuste se aplican al generado, NO al gasto.
        const rGastHist = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: "SELECT " +
                 "  COALESCE(SUM(CASE WHEN tipo = 'debito' THEN monto ELSE 0 END),0) as gastado, " +
                 "  COALESCE(SUM(CASE WHEN tipo = 'credito_ajuste' THEN monto ELSE 0 END),0) as ajuste_total " +
                 "FROM activos_transacciones WHERE user_id = " + liderReg
        });
        montoGastadoHistorico = parseFloat(rGastHist.rows?.[0]?.gastado || 0);
        window.ACTIVOS_AJUSTE_INFO = parseFloat(rGastHist.rows?.[0]?.ajuste_total || 0);
    } catch(e) {}

    // ── Débitos REALES por mes (para que la tabla FIFO muestre consumo real por mes) ──
    let _debitosPorMes = {};
    try {
        const rDebMes = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: "SELECT mes, COALESCE(SUM(monto),0) as total FROM activos_transacciones " +
                 "WHERE user_id = " + liderReg + " AND tipo = 'debito' GROUP BY mes"
        });
        (rDebMes.rows || []).forEach(r => { _debitosPorMes[r.mes] = parseFloat(r.total || 0); });
        // [DEBUG-TEMP] — remover después de diagnosticar
        console.log('[FIFO-DEBUG] _debitosPorMes:', JSON.stringify(_debitosPorMes), '| rows:', rDebMes.rows?.length, '| liderReg:', liderReg);
    } catch(e) {
        console.error('[FIFO-DEBUG] Error en query debitosPorMes:', e);
    }

    // ── Ajustes Maestro por mes (credito_ajuste) — se aplican como reducción al generado de cada mes ──
    let _ajustesPorMes = {};
    try {
        const rAjMes = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: "SELECT mes, SUM(monto) as total FROM activos_transacciones WHERE user_id = " + liderReg + " AND tipo = 'credito_ajuste' GROUP BY mes"
        });
        (rAjMes.rows || []).forEach(r => { _ajustesPorMes[r.mes] = parseFloat(r.total || 0); });
    } catch(e) {}

    // ── Gasto filtrado al mes del filtro (para widget de arqueo mensual) ──
    let montoGastadoMes = 0;
    try {
        const rGastMes = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: "SELECT COALESCE(SUM(monto),0) as gastado FROM activos_transacciones " +
                 "WHERE user_id = " + liderReg + " AND tipo = 'debito' AND mes = '" + mes + "'"
        });
        montoGastadoMes = parseFloat(rGastMes.rows?.[0]?.gastado || 0);
    } catch(e) {}

    // ── REGLA MISMO MES: el derecho a activos del mes N requiere compra en N ──
    const [anioNum, mesNum] = mes.split('-').map(Number);
    // Revisar calificación: ¿compró >= precio_caja en el MISMO mes?
    const _umbralCalif = COMMISSION_CONFIG.precio_caja[moneda.codigo] || COMMISSION_CONFIG.precio_caja?.MXN || 4500;
    let _compro = false;
    // Primero revisar en cache local (compras históricas)
    // Usamos length > 0 (igual que n8n: has_sale > 0) — cualquier compra personal califica,
    // ya que ventas pagadas parcialmente con activos pueden tener total < precioCaja
    if (window._comprasHistoricas) {
        const comprasN0 = window._comprasHistoricas.filter(v => v.nivel === 0 && v.mesStr === mes);
        _compro = comprasN0.length > 0;
    }
    // Fallback: consultar BD (SUM de total, no COUNT)
    if (!_compro) {
        try {
            const _sumExpr = "COALESCE(SUM(total + COALESCE((regexp_replace(substring(comentario from '(?:^|[^A-Za-z_])ACTIVOS(?:/[^\\\\s$]+)?\\\\s*\\\\$([0-9.,]+)'), ',', '', 'g'))::numeric, 0)), 0)";
            const sqlMesCur = liderUUID
                ? "SELECT " + _sumExpr + " as total_compras FROM venta WHERE cliente_id = '" + liderUUID + "' AND TO_CHAR(fecha_venta,'YYYY-MM') = '" + mes + "' AND approved = 1"
                : "SELECT " + _sumExpr + " as total_compras FROM venta WHERE cliente_id IN (SELECT id FROM cliente WHERE registro = " + liderReg + ") AND TO_CHAR(fecha_venta,'YYYY-MM') = '" + mes + "' AND approved = 1";

            const rCur = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlMesCur });
            _compro = parseFloat(rCur.rows?.[0]?.total_compras || 0) > 0;
        } catch(e) { console.warn('compro check error:', e.message); }
    }
    window.ACTIVOS_COMPRO = _compro;

    // Elementos calculados para Reglas y Galardones
    const _cajasEste = comprasMes.reduce((s, v) => s + v.cajas, 0) || (user.frontales || 1);
    const _n1Act = (typeof contarFrontalesActivos === 'function')
        ? contarFrontalesActivos(comprasMes)
        : (function(){ const c={}; comprasMes.filter(v=>v.nivel===1).forEach(v=>{ const r=v.clienteReg; if(r) c[r]=(c[r]||0)+parseFloat(v.cajas||0); }); return Object.values(c).filter(x=>Math.floor(x)>=1).length; })();
    window.ACTIVOS_N1_COUNT = _n1Act;
    
    const _galFromLD = (typeof LIDERES_DATA !== 'undefined' && LIDERES_DATA.length)
        ? (LIDERES_DATA.find(u2 => u2.registro == user.registro || u2.id == user.id)?.galardon || null)
        : null;
    window.ACTIVOS_GALARDON = _galFromLD || user.galardon || null;
    renderGalardonesGrid(window.ACTIVOS_GALARDON, _cajasEste, _n1Act || user.frontales || 0);

    // Es Empresario LED?
    let _esEmpresarioLed = false;
    try {
        const sqlEmp = "SELECT es_empresario_led FROM cliente WHERE registro = " + liderReg + " LIMIT 1";
        const rEmp = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlEmp });
        _esEmpresarioLed = rEmp.rows?.[0]?.es_empresario_led === true;
    } catch(e) {}

    // CALCULAR EL PLAN DULET USANDO FUENTE ÚNICA DE VERDAD (SSOT)
    const calcPlan = (typeof calcularPlanDulet === 'function') 
        ? calcularPlanDulet(_compro, _n1Act || user.frontales || 0, window.ACTIVOS_GALARDON, _esEmpresarioLed, cajasEnv, _precioCaja)
        : { bruto: 0, final: 0, n1: 0, n2: 0, n3: 0, n4: 0, nTipo: 'ok', nTxto: '', nSub: '' };
    
    let montoGenerado = calcPlan.final;
    window.ACTIVOS_MONTO_GENERADO = montoGenerado;
    window.ACTIVOS_CALC_DATA = calcPlan;

    // Marcar como empresario_led en DB de forma permanente si el bruto rebasó umbral
    const _umbralLed = COMMISSION_CONFIG.umbral_empresario_led?.[moneda.codigo] || 10000;
    if (!_esEmpresarioLed && calcPlan.bruto >= _umbralLed) {
        try { await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: "UPDATE cliente SET es_empresario_led = true WHERE registro = " + liderReg }); } catch(e) {}
    }

    // ── CONSTRUIR LEDGER HISTÓRICO (M-4 a M actual) para Bolsa Global ──
    // IMPORTANTE: Usar mes REAL del sistema (no el filtro) para la ventana FIFO.
    // Igual que el QR (fuente de verdad) y Centros de Apoyo.
    // El filtro solo afecta el detalle de ventas del mes, NO el saldo disponible.
    // M-0 (mes actual) entra como 'pendiente_liberacion' y NO suma a saldoDisponible.
    const _nowReal = new Date();
    const _mesRealActual = _nowReal.getFullYear() + '-' + String(_nowReal.getMonth() + 1).padStart(2, '0');
    const [_realAnio, _realMes] = _mesRealActual.split('-').map(Number);
    const _numMesesHist = Math.max(4, (_realAnio - 2026) * 12 + (_realMes - 3));
    const historialBolsa = [];
    for (let i = _numMesesHist; i >= 0; i--) {
        const dIt = new Date(_realAnio, _realMes - 1, 1); dIt.setMonth(dIt.getMonth() - i);
        const mIt = dIt.getFullYear() + '-' + String(dIt.getMonth()+1).padStart(2,'0');
        
        const iterCompras = (window._comprasHistoricas||[]).filter(v => v.mesStr === mIt);
        // compro = ¿hizo alguna compra personal (N0) en el MISMO mes?
        // Usamos length > 0 (igual que n8n: has_sale > 0) para alinearse con Centros y workflow
        const iterComprasN0 = (window._comprasHistoricas||[]).filter(v => v.nivel === 0 && v.mesStr === mIt);
        const iterCompro = iterComprasN0.length > 0;
        const iterN1Act = (typeof contarFrontalesActivos === 'function')
            ? contarFrontalesActivos(iterCompras)
            : (function(){ const c={}; iterCompras.filter(v=>v.nivel===1).forEach(v=>{ const r=v.clienteReg; if(r) c[r]=(c[r]||0)+parseFloat(v.cajas||0); }); return Object.values(c).filter(x=>Math.floor(x)>=1).length; })();
        const iterCajas = { n1:0, n2:0, n3:0, n4:0 };
        iterCompras.forEach(v => { if(v.nivel>0) iterCajas['n'+v.nivel] += (v.cajas||0); });

        const calcIter = (typeof calcularPlanDulet === 'function') 
            ? calcularPlanDulet(iterCompro, iterN1Act || user.frontales || 0, window.ACTIVOS_GALARDON, _esEmpresarioLed, iterCajas, _precioCaja)
            : { final: 0 };
        // Aplicar ajustes maestro (credito_ajuste) al generado — igual que el QR (fuente de verdad)
        const ajusteMes = _ajustesPorMes[mIt] || 0;
        const genConAjuste = Math.max(0, calcIter.final + ajusteMes);
        historialBolsa.push({ mes: mIt, generado: genConAjuste, generadoOriginal: calcIter.final, ajusteMaestro: Math.abs(ajusteMes), compro: iterCompro });
    }

    // Procesar FIFO y Extracción Real Mensual
    let globalLedger = { saldoDisponible: 0, expiradoTotal: 0, detalleMeses: [] };
    if (typeof calcularBolsaGlobal === 'function') {
        const _uLib = window._cierreActivosConfig?.ultimo_mes_liberado || null;
        globalLedger = calcularBolsaGlobal(historialBolsa, montoGastadoHistorico, _mesRealActual, _debitosPorMes, _mesRealActual, _uLib);
        montoGenerado = calcPlan.final; // Esto es lo generado específicamente en el mes visualizado (No tiene nada que ver con la disponibilidad actual)
    }

    window.ACTIVOS_MONTO_GENERADO = montoGenerado;
    window.ACTIVOS_BOLSA_GLOBAL = globalLedger;

    // ── Guardar detalle de ventas individual para el modal y desglose
    const _pct = COMMISSION_CONFIG.pct;
    const _nivelPct = [0, _pct.n1/100, _pct.n2/100, _pct.n3/100, _pct.n4/100];
    window.ACTIVOS_DETALLE = comprasMes.map(v => {
        const nivelIdx   = Math.max(0, Math.min(4, v.nivel ?? 1));
        const pctVal     = (_nivelPct[nivelIdx] ?? 0);
        // SSOT: solo cajas completas generan comisión (alineado con reglas_compensacion.js)
        const comision   = Math.floor(v.cajas || 0) * _precioCaja * pctVal;
        return {
            nivel:     nivelIdx,
            cajas:     v.cajas,
            id:        v.clienteReg,
            nombre:    v.cliente,
            pct:       Math.round(pctVal * 100),
            comision,
            usoActivos: false,
            montoVenta: v.totalNum,
            tipoPago:  v.tipoPago,
            fecha:     v.fechaStr
        };
    });

    // ── Llenar saldo widgets (Agregando Banner de Bolsa Global) ──
    const dispEl = document.getElementById('activoDisp');
    const genEl  = document.getElementById('activoGenerado');
    const gasEl  = document.getElementById('activoGastado');
    
    // La bolsa muestra el saldo FIFO directo — los ajustes ya están absorbidos en cada mes
    const finalBolsaSaldo = globalLedger.saldoDisponible;
    const _bolsaLabel = window.ACTIVOS_COMPRO ? 'BILLETERA (GLOBAL)' : 'BILLETERA (GLOBAL) — NO GENERA ESTE MES';
    if (dispEl) dispEl.innerHTML = _fmtActivo(finalBolsaSaldo, moneda) + '<br><span style="font-size:0.6rem;opacity:0.8">' + _bolsaLabel + '</span>';
    // ── Llenar tabla de auditoría (Desglose FIFO) ──
    // Mostrar los últimos 5 meses en la vista de tabla para mantener el diseño compacto y limpio
    const _tablaDetalle = (globalLedger.detalleMeses || []).slice(-5);
    // Calcular totales FIFO vigentes para que Gen - Consumido = Saldo
    const _fifoVigentes = _tablaDetalle.filter(d => d.estatus !== 'expirado' && d.estatus !== 'pendiente_liberacion');
    const _totalGenVigente = _fifoVigentes.reduce((s, d) => s + (d.generado || 0), 0);
    const _totalConsumido = _fifoVigentes.reduce((s, d) => s + (d.consumidoFIFO || 0), 0);
    if (genEl)  genEl.textContent  = _fmtActivo(_totalGenVigente, moneda);
    if (gasEl)  gasEl.textContent  = _fmtActivo(_totalConsumido,  moneda);
    const auditBody = document.getElementById('bolsaGlobalAuditBody');
    if (auditBody && _tablaDetalle) {
        if (!_tablaDetalle.length) {
            auditBody.innerHTML = '<tr><td colspan="4" style="text-align:center;padding:1rem">Sin historial reciente</td></tr>';
        } else {
            auditBody.innerHTML = _tablaDetalle.map(d => {
                const confColor = d.estatus === 'disponible' ? '#4ade80' : d.estatus === 'sin_derecho' ? '#fb923c' : d.estatus === 'pendiente_liberacion' ? '#fbbf24' : d.estatus === 'consumido' ? '#9ca3af' : '#f87171';
                const confTxt = d.estatus === 'sin_derecho' ? 'SIN DERECHO' : d.estatus.replaceAll('_', ' ').toUpperCase();
                return `<tr style="cursor:pointer;transition:background 0.15s" onmouseover="this.style.background='rgba(99,102,241,0.08)'" onmouseout="this.style.background='transparent'" onclick="abrirModalReporteActivos('${d.mes}')" title="Ver desglose de consumos de ${d.mes}">
                    <td style="font-weight:600;font-family:monospace;padding:6px 0">${d.mes} <span style="font-size:0.65rem;color:#818cf8;opacity:0.8">📊</span></td>
                    <td style="padding:6px 0">${_fmtActivo(d.generado, moneda)}</td>
                    <td style="padding:6px 0;color:var(--danger)">${d.consumidoFIFO > 0 ? _fmtActivo(d.consumidoFIFO, moneda) : '-'}</td>
                    <td style="text-align:right;padding:6px 0"><span style="color:${confColor};font-weight:700;font-size:0.65rem;border:1px solid ${confColor}40;padding:2px 6px;border-radius:4px" title="Expirado: ${_fmtActivo(d.expiradoLocal||0, moneda)}">${confTxt}</span></td>
                </tr>`;
            }).join('');
        }
    }
    const lblCreditos = document.getElementById('lblCreditosPendientes');
    if (lblCreditos) {
        const ajInfo = window.ACTIVOS_AJUSTE_INFO || 0;
        if (isAdminOrMaster() && ajInfo !== 0) {
            const absAj = Math.abs(ajInfo);
            const signo = ajInfo < 0 ? 'restados' : 'sumados';
            const color = ajInfo < 0 ? 'var(--danger)' : 'var(--success)';
            lblCreditos.innerHTML = `<span style="font-size:0.75rem;color:var(--text-dim)">ℹ️ Ajustes Maestro aplicados: <strong style="color:${color}">${_fmtActivo(absAj, moneda)}</strong> ${signo} (reducen el generado FIFO internamente).</span>`;
        } else lblCreditos.innerHTML = '';
    }
    
    // Validar visualización del Botón de Ajuste (ESTRICTO: solo Rol Master)
    const esMasterRole = typeof BO_AUTH !== 'undefined' && BO_AUTH.hasRole && BO_AUTH.hasRole('master');
    const btnAjuste = document.getElementById('btnAjusteActivos');
    if (btnAjuste) btnAjuste.style.display = esMasterRole ? 'inline-block' : 'none';
    const btnReporte = document.getElementById('btnReporteActivos');
    if (btnReporte) btnReporte.style.display = isAdminOrMaster() ? 'inline-block' : 'none';
    const btnCsvGlobal = document.getElementById('btnCsvActivosGlobal');
    if (btnCsvGlobal) btnCsvGlobal.style.display = isAdminOrMaster() ? 'inline-block' : 'none';

    // ── Detalle de compras del mes ───────────────────────────────────────
    const tbodyDet = document.getElementById('activosDetalleBody');
    // Marcar ventas que usaron activos desde activos_transacciones
    let ventasConActivos = new Set();
    let montoGastado = 0;
    try {
        const mesStr2 = String(filtroAnio) + '-' + String(filtroMes).padStart(2,'0');
        const rActUsados = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: "SELECT venta_id, monto FROM activos_transacciones WHERE tipo = 'debito' AND mes = '" + mesStr2 + "'"
        });
        (rActUsados.rows || []).forEach(r => {
            ventasConActivos.add(String(r.venta_id));
            montoGastado += parseFloat(r.monto || 0);
        });
    } catch(e) {}

    if (tbodyDet) {
        const esLiderSum = CURRENT_USER.rol !== 'master' && CURRENT_USER.rol !== 'admin' && CURRENT_USER.rol !== 'operativo';
        const colsSum = esLiderSum ? 5 : 7;
        const headerRow = '<tr style="background:rgba(255,255,255,.03);font-size:.72rem;color:var(--text-dim)">' +
            '<td colspan="' + colsSum + '" style="padding:.4rem 1rem">' +
            '📅 ' + comprasMes.length + ' compras en ' + mes +
            (esLiderSum ? '' : ' · Total: ' + moneda.simbolo + montoGenerado.toLocaleString(moneda.locale, {minimumFractionDigits:2}) + ' ' + moneda.codigo +
            (montoGastado > 0 ? ' · <span style="color:#a5b4fc">Activos usados: ' + moneda.simbolo + montoGastado.toLocaleString(moneda.locale) + '</span>' : '')) +
            '</td></tr>';
        tbodyDet.innerHTML = headerRow;
        const pagEl = document.getElementById('activosDetPag');
        if (!comprasMes.length) {
            _activosDet = [];  // Limpiar datos stale del usuario anterior
            tbodyDet.innerHTML += '<tr><td colspan="7" style="text-align:center;color:var(--text-dim);padding:2rem;">Sin compras en ' + mes + '</td></tr>';
            if (pagEl) pagEl.style.display = 'none';
        } else {
            const uRegFilter = String(ACTIVOS_USER?.registro || CURRENT_USER?.registro);
            var _comprasPropias = comprasMes.filter(function(v){ return String(v.clienteReg) === uRegFilter; });
            _activosDet = comprasMes
                .filter(function(v){ return String(v.clienteReg) !== uRegFilter; })
                .map(function(v){
                    return Object.assign({}, v, {
                        usaActivos: ventasConActivos.has(String(v.notaFull)),
                        _esPropia:  false
                    });
                })
                .sort(function(a, b){
                    if (a._esPropia && !b._esPropia) return -1;
                    if (!a._esPropia && b._esPropia) return 1;
                    return (a.nivel || 0) - (b.nivel || 0);
                });
            // ACTIVOS_COMPRO ya fue asignado correctamente (regla mes N-1). No sobreescribir.
            window.ACTIVOS_COMPRAS_PROPIAS = _comprasPropias.length;
            _activosDetPag = 1;
            if (pagEl) pagEl.style.display = '';
            renderActivosDetPagina();
        }
    }


    // ── Guardar referencias globales para drilldown onclick ─────────────────
    _drillComprasMes = comprasMes || [];
    _drillLiderUUID  = liderUUID  || '';
    _drillMes        = mes        || '';

    // ── Gráfica: PERSONAS por nivel en la cadena del líder (CTE recursiva) ──
    // liderUUID ya está resuelto arriba en la función
    let personasPorNivel = [0, 0, 0, 0];
    try {
        if (liderUUID && liderUUID.includes('-')) {
            const cteSql =
                "WITH RECURSIVE red AS (" +
                " SELECT id, patrocinador, 1 AS nivel FROM cliente WHERE patrocinador = '" + liderUUID + "'" +
                " UNION ALL" +
                " SELECT c.id, c.patrocinador, r.nivel + 1 FROM cliente c INNER JOIN red r ON c.patrocinador = r.id WHERE r.nivel < 4" +
                ") SELECT nivel, COUNT(*) AS personas FROM red GROUP BY nivel ORDER BY nivel";
            const rPersonas = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: cteSql });
            (rPersonas.rows || []).forEach(r => {
                const niv = parseInt(r.nivel);
                if (niv >= 1 && niv <= 4) personasPorNivel[niv - 1] = parseInt(r.personas || 0);
            });
        }
    } catch(e) {
        console.warn('Red personas CTE error:', e.message);
    }

    const totalRed = personasPorNivel.reduce((s, v) => s + v, 0);
    _drillPersonasTotales = personasPorNivel.slice(); // guardar totales para paginación

    if (chartNiv) { chartNiv.destroy(); chartNiv = null; }
    const canvas = document.getElementById('chartNiveles');
    if (canvas) {
        chartNiv = new Chart(canvas, {
        type: 'bar',
        data: {
            labels: [
                'N1 (' + personasPorNivel[0] + ')',
                'N2 (' + personasPorNivel[1] + ')',
                'N3 (' + personasPorNivel[2] + ')',
                'N4 (' + personasPorNivel[3] + ')'
            ],
            datasets: [{
                label: 'Personas en cadena',
                data: personasPorNivel,
                backgroundColor: [
                    'rgba(99,102,241,.85)',
                    'rgba(59,130,246,.75)',
                    'rgba(16,185,129,.65)',
                    'rgba(245,158,11,.55)'
                ],
                borderRadius: 8
            }]
        },
        options: {
            responsive: true, maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
                tooltip: {
                    callbacks: {
                        label: ctx => ' ' + ctx.raw + ' personas en cadena',
                        afterLabel: ctx => {
                            const isAdm = isAdminOrMaster();
                            const pct = totalRed > 0 ? Math.round(ctx.raw / totalRed * 100) : 0;
                            return pct + '% de la cadena total (' + totalRed + ')';
                        }
                    }
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    grid:  { color: 'rgba(63,63,70,.2)' },
                    ticks: { callback: v => v + ' pers.' }
                },
                x: { grid: { display: false } }
            }
        }
    });
    }

    // ── Mostrar total de red en el subtítulo ─────────────────────────────
    const subEl2 = document.getElementById('activosSub');
    if (subEl2 && totalRed > 0) {
        subEl2.textContent = 'Cadena total: ' + totalRed + ' personas · ' + mes;
    }

    // ── Gráfica 2: CAJAS del mes por nivel en la cadena (N1, N2, N3, N4) ──
    const cajasPorNivel = [0, 0, 0, 0];
    (comprasMes || []).forEach(v => {
        const niv = parseInt(v.nivel);
        if (niv >= 1 && niv <= 4) {
            cajasPorNivel[niv - 1] += (parseFloat(v.cajas) || 0);
        }
    });
    for (let i = 0; i < 4; i++) {
        cajasPorNivel[i] = Math.round(cajasPorNivel[i] * 10) / 10;
    }
    const totalCajasMes = Math.round(cajasPorNivel.reduce((s, v) => s + v, 0) * 10) / 10;
    
    const lblCajasH = document.getElementById('lblCajasMesHeader');
    if (lblCajasH) {
        lblCajasH.textContent = totalCajasMes + ' cajas totales · ' + mes;
    }

    if (chartCajasNiv) { chartCajasNiv.destroy(); chartCajasNiv = null; }
    const canvasCajas = document.getElementById('chartCajasNiveles');
    if (canvasCajas) {
        chartCajasNiv = new Chart(canvasCajas, {
            type: 'bar',
            data: {
                labels: [
                    'N1 (' + cajasPorNivel[0] + ')',
                    'N2 (' + cajasPorNivel[1] + ')',
                    'N3 (' + cajasPorNivel[2] + ')',
                    'N4 (' + cajasPorNivel[3] + ')'
                ],
                datasets: [{
                    label: 'Cajas del mes',
                    data: cajasPorNivel,
                    backgroundColor: [
                        'rgba(34,197,94,.85)',
                        'rgba(16,185,129,.75)',
                        'rgba(20,184,166,.65)',
                        'rgba(6,182,212,.55)'
                    ],
                    borderRadius: 8
                }]
            },
            options: {
                responsive: true, maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: ctx => ' ' + ctx.raw + ' cajas equivalentes',
                            afterLabel: ctx => {
                                const isAdm = isAdminOrMaster();
                                const pct = totalCajasMes > 0 ? Math.round(ctx.raw / totalCajasMes * 100) : 0;
                                return pct + '% de las cajas del mes (' + totalCajasMes + ')';

                            }
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        grid:  { color: 'rgba(63,63,70,.2)' },
                        ticks: { callback: v => v + ' cajas' }
                    },
                    x: { grid: { display: false } }
                }
            }
        });
    }

    // ── Gráfica 3: NUEVOS INSCRITOS del mes por nivel en la cadena (N1, N2, N3, N4) ──
    let inscritosPorNivel = [0, 0, 0, 0];
    try {
        if (liderUUID && liderUUID.includes('-')) {
            const sqlInscritos =
                "WITH RECURSIVE red AS (" +
                "  SELECT id, patrocinador, created_at, 1 AS nivel FROM cliente WHERE patrocinador = '" + liderUUID + "'" +
                "  UNION ALL" +
                "  SELECT c.id, c.patrocinador, c.created_at, r.nivel + 1 FROM cliente c INNER JOIN red r ON c.patrocinador = r.id WHERE r.nivel < 4" +
                ") SELECT nivel, COUNT(*) AS inscritos FROM red WHERE TO_CHAR(created_at, 'YYYY-MM') = '" + mes + "' GROUP BY nivel ORDER BY nivel";
            const rIns = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlInscritos });
            (rIns.rows || []).forEach(r => {
                if (r.nivel) {
                    const niv = parseInt(r.nivel);
                    if (niv >= 1 && niv <= 4) inscritosPorNivel[niv - 1] = parseInt(r.inscritos || 0);
                }
            });
        }
    } catch(e) {
        console.warn('Inscritos CTE error:', e.message);
    }

    const totalInscritosMes = inscritosPorNivel.reduce((s, v) => s + v, 0);
    const lblInsH = document.getElementById('lblInscritosMesHeader');
    if (lblInsH) {
        lblInsH.textContent = totalInscritosMes + ' inscritos · ' + mes;
    }

    if (chartInscritosNiv) { chartInscritosNiv.destroy(); chartInscritosNiv = null; }
    const canvasIns = document.getElementById('chartInscritosNiveles');
    if (canvasIns) {
        chartInscritosNiv = new Chart(canvasIns, {
            type: 'bar',
            data: {
                labels: [
                    'N1 (' + inscritosPorNivel[0] + ')',
                    'N2 (' + inscritosPorNivel[1] + ')',
                    'N3 (' + inscritosPorNivel[2] + ')',
                    'N4 (' + inscritosPorNivel[3] + ')'
                ],
                datasets: [{
                    label: 'Nuevos inscritos',
                    data: inscritosPorNivel,
                    backgroundColor: [
                        'rgba(96,165,250,.85)',
                        'rgba(59,130,246,.75)',
                        'rgba(147,51,234,.65)',
                        'rgba(236,72,153,.55)'
                    ],
                    borderRadius: 8
                }]
            },
            options: {
                responsive: true, maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        callbacks: {
                            label: ctx => ' ' + ctx.raw + ' nuevos inscritos',
                            afterLabel: ctx => {
                                const isAdm = isAdminOrMaster();
                                const pct = totalInscritosMes > 0 ? Math.round(ctx.raw / totalInscritosMes * 100) : 0;
                                return pct + '% de inscritos del mes (' + totalInscritosMes + ')';

                            }
                        }
                    }
                },
                scales: {
                    y: {
                        beginAtZero: true,
                        grid:  { color: 'rgba(63,63,70,.2)' },
                        ticks: { callback: v => v + ' pers.' }
                    },
                    x: { grid: { display: false } }
                }
            }
        });
    }
}


/* ============================================================
   DRILLDOWN DE GRÁFICAS POR NIVEL — Solo admin/master/operativo
   ============================================================ */

// ── Wrappers para los onclick de los divs contenedores de cada gráfica ───────
// Usa posición X relativa para detectar la barra — más confiable que getElementsAtEventForMode
function _nivelDesdeClick(event, numBars) {
    const rect = event.currentTarget.getBoundingClientRect();
    const relX  = event.clientX - rect.left;
    const barW  = rect.width / numBars;
    const idx   = Math.floor(relX / barW); // 0-based
    return Math.min(Math.max(idx + 1, 1), numBars); // 1-4
}

function _onClickChartNiveles(event) {
    // DEBUG: sin guard de rol
    if (!chartNiv) { console.warn('[DRILLDOWN] chartNiv es null'); return; }
    const nivel = _nivelDesdeClick(event, 4);
    console.log('[DRILLDOWN] Personas nivel:', nivel, '| rol:', CURRENT_USER?.rol, '| uuid:', _drillLiderUUID);
    mostrarDrilldownPersonas(nivel);
}

function _onClickChartCajasNiveles(event) {
    // DEBUG: sin guard de rol
    if (!chartCajasNiv) { console.warn('[DRILLDOWN] chartCajasNiv es null'); return; }
    const nivel = _nivelDesdeClick(event, 4);
    console.log('[DRILLDOWN] Cajas nivel:', nivel, '| rol:', CURRENT_USER?.rol);
    mostrarDrilldownCajas(nivel);
}

function _onClickChartInscritosNiveles(event) {
    // DEBUG: sin guard de rol
    if (!chartInscritosNiv) { console.warn('[DRILLDOWN] chartInscritosNiv es null'); return; }
    const nivel = _nivelDesdeClick(event, 4);
    console.log('[DRILLDOWN] Inscritos nivel:', nivel, '| rol:', CURRENT_USER?.rol);
    mostrarDrilldownInscritos(nivel);
}

function _abrirModalDrilldown(title, subtitle, html) {
    const m = document.getElementById('modalNivelDrilldown');
    if (!m) return;
    document.getElementById('ndTitle').textContent    = title;
    document.getElementById('ndSubtitle').textContent = subtitle;
    document.getElementById('ndBody').innerHTML        = html;
    m.style.display = 'flex';
}

function cerrarModalNivelDrilldown() {
    const m = document.getElementById('modalNivelDrilldown');
    if (m) m.style.display = 'none';
}

// ── Drilldown Gráfica 1: Personas Totales por Nivel ──────────────────────────
async function mostrarDrilldownPersonas(nivelIdx) {
    _ddPagNivel  = nivelIdx;
    _ddPagOffset = 0;
    _abrirModalDrilldown(
        `👥 Nivel ${nivelIdx} — Personas en la Cadena`,
        `Cargando…`,
        '<div style="text-align:center;padding:2rem;color:var(--text-dim)">Cargando…</div>'
    );
    await _fetchDrillPersonas();
}

async function _fetchDrillPersonas() {
    const nivelIdx = _ddPagNivel;
    const offset   = _ddPagOffset;
    const u = _drillLiderUUID;
    if (!u) {
        document.getElementById('ndBody').innerHTML = '<div style="color:#f87171;padding:1rem">Sin UUID de líder. Recarga la página.</div>';
        return;
    }
    document.getElementById('ndBody').innerHTML = '<div style="text-align:center;padding:2rem;color:var(--text-dim)">Cargando página…</div>';
    try {
        const lim = _DD_PAGE_SIZE;
        const sqlMap = {
            1: `SELECT c1.nombre, c1.ape_p AS apellido, c1.registro, TO_CHAR(c1.created_at,'YYYY-MM-DD') AS fecha_inscripcion FROM cliente c1 WHERE c1.patrocinador = '${u}' ORDER BY c1.created_at DESC LIMIT ${lim} OFFSET ${offset}`,
            2: `SELECT c2.nombre, c2.ape_p AS apellido, c2.registro, TO_CHAR(c2.created_at,'YYYY-MM-DD') AS fecha_inscripcion FROM cliente c1 JOIN cliente c2 ON c2.patrocinador = c1.id WHERE c1.patrocinador = '${u}' ORDER BY c2.created_at DESC LIMIT ${lim} OFFSET ${offset}`,
            3: `SELECT c3.nombre, c3.ape_p AS apellido, c3.registro, TO_CHAR(c3.created_at,'YYYY-MM-DD') AS fecha_inscripcion FROM cliente c1 JOIN cliente c2 ON c2.patrocinador = c1.id JOIN cliente c3 ON c3.patrocinador = c2.id WHERE c1.patrocinador = '${u}' ORDER BY c3.created_at DESC LIMIT ${lim} OFFSET ${offset}`,
            4: `SELECT c4.nombre, c4.ape_p AS apellido, c4.registro, TO_CHAR(c4.created_at,'YYYY-MM-DD') AS fecha_inscripcion FROM cliente c1 JOIN cliente c2 ON c2.patrocinador = c1.id JOIN cliente c3 ON c3.patrocinador = c2.id JOIN cliente c4 ON c4.patrocinador = c3.id WHERE c1.patrocinador = '${u}' ORDER BY c4.created_at DESC LIMIT ${lim} OFFSET ${offset}`
        };
        const sql = sqlMap[nivelIdx];
        if (!sql) throw new Error('Nivel inválido: ' + nivelIdx);
        const r = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        const rows = r.rows || [];

        const total      = _drillPersonasTotales[nivelIdx - 1] || 0;
        const pagActual  = Math.floor(offset / lim) + 1;
        const totalPags  = total > 0 ? Math.ceil(total / lim) : '?';
        const desde      = offset + 1;
        const hasta      = offset + rows.length;
        const hasPrev    = offset > 0;
        const hasNext    = rows.length === lim; // si llena, probablemente hay más

        document.getElementById('ndSubtitle').textContent = `${total} personas en N${nivelIdx} · pág. ${pagActual}/${totalPags}`;

        if (!rows.length && offset === 0) {
            document.getElementById('ndBody').innerHTML = '<div style="text-align:center;padding:2rem;color:var(--text-dim)">Sin personas en este nivel.</div>';
            return;
        }

        const btnStyle = (active) => `padding:.3rem .9rem;background:rgba(255,255,255,${active ? '.1' : '.03'});border:1px solid var(--border);border-radius:6px;color:${active ? 'var(--text-main)' : 'var(--text-dim)'};cursor:${active ? 'pointer' : 'not-allowed'};font-size:.8rem;`;
        const pagBar = `
        <div style="display:flex;align-items:center;justify-content:space-between;padding:.5rem .75rem;background:rgba(255,255,255,.03);border-radius:8px;margin-bottom:.75rem;">
            <button onclick="_ddPersonasPrev()" ${hasPrev ? '' : 'disabled'} style="${btnStyle(hasPrev)}">&#8592; Anterior</button>
            <span style="color:var(--text-dim);font-size:.78rem;">Mostrando ${desde}–${hasta} de ${total}</span>
            <button onclick="_ddPersonasNext()" ${hasNext ? '' : 'disabled'} style="${btnStyle(hasNext)}">Siguiente &#8594;</button>
        </div>`;

        document.getElementById('ndBody').innerHTML = pagBar + _renderDrillTable(rows, 'personas');
    } catch(e) {
        document.getElementById('ndBody').innerHTML = `<div style="color:#f87171;padding:1rem">Error: ${e.message}</div>`;
    }
}

function _ddPersonasPrev() {
    if (_ddPagOffset <= 0) return;
    _ddPagOffset = Math.max(0, _ddPagOffset - _DD_PAGE_SIZE);
    _fetchDrillPersonas();
}

function _ddPersonasNext() {
    _ddPagOffset += _DD_PAGE_SIZE;
    _fetchDrillPersonas();
}


// ── Drilldown Gráfica 2: Cajas del Mes por Nivel ─────────────────────────────
function mostrarDrilldownCajas(nivelIdx) {
    const filas = _drillComprasMes.filter(v => parseInt(v.nivel) === nivelIdx);
    _abrirModalDrilldown(
        `📦 Nivel ${nivelIdx} — Cajas del Mes`,
        `Mes: ${_drillMes} · ${filas.length} compra${filas.length !== 1 ? 's' : ''}`,
        filas.length
            ? _renderDrillTableCajas(filas)
            : '<div style="text-align:center;padding:2rem;color:var(--text-dim)">Sin compras en este nivel para el mes seleccionado.</div>'
    );
}

// ── Drilldown Gráfica 3: Nuevos Inscritos por Nivel ──────────────────────────
async function mostrarDrilldownInscritos(nivelIdx) {
    _abrirModalDrilldown(
        `🆕 Nivel ${nivelIdx} — Nuevos Inscritos`,
        `Mes: ${_drillMes} · Consultando…`,
        '<div style="text-align:center;padding:2rem;color:var(--text-dim)">Cargando…</div>'
    );
    try {
        if (!_drillLiderUUID) throw new Error('Sin UUID de líder');
        const u = _drillLiderUUID;
        const m = _drillMes;
        // Query plana por nivel con filtro de mes de inscripción (sin CTE recursiva)
        const sqlMap = {
            1: `SELECT c1.nombre, c1.ape_p AS apellido, c1.registro, TO_CHAR(c1.created_at,'YYYY-MM-DD') AS fecha_inscripcion FROM cliente c1 WHERE c1.patrocinador = '${u}' AND TO_CHAR(c1.created_at,'YYYY-MM') = '${m}' ORDER BY c1.created_at DESC LIMIT 300`,
            2: `SELECT c2.nombre, c2.ape_p AS apellido, c2.registro, TO_CHAR(c2.created_at,'YYYY-MM-DD') AS fecha_inscripcion FROM cliente c1 JOIN cliente c2 ON c2.patrocinador = c1.id WHERE c1.patrocinador = '${u}' AND TO_CHAR(c2.created_at,'YYYY-MM') = '${m}' ORDER BY c2.created_at DESC LIMIT 300`,
            3: `SELECT c3.nombre, c3.ape_p AS apellido, c3.registro, TO_CHAR(c3.created_at,'YYYY-MM-DD') AS fecha_inscripcion FROM cliente c1 JOIN cliente c2 ON c2.patrocinador = c1.id JOIN cliente c3 ON c3.patrocinador = c2.id WHERE c1.patrocinador = '${u}' AND TO_CHAR(c3.created_at,'YYYY-MM') = '${m}' ORDER BY c3.created_at DESC LIMIT 300`,
            4: `SELECT c4.nombre, c4.ape_p AS apellido, c4.registro, TO_CHAR(c4.created_at,'YYYY-MM-DD') AS fecha_inscripcion FROM cliente c1 JOIN cliente c2 ON c2.patrocinador = c1.id JOIN cliente c3 ON c3.patrocinador = c2.id JOIN cliente c4 ON c4.patrocinador = c3.id WHERE c1.patrocinador = '${u}' AND TO_CHAR(c4.created_at,'YYYY-MM') = '${m}' ORDER BY c4.created_at DESC LIMIT 300`
        };
        const sql = sqlMap[nivelIdx];
        if (!sql) throw new Error('Nivel inválido: ' + nivelIdx);
        const r = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
        const rows = r.rows || [];
        document.getElementById('ndSubtitle').textContent = `Mes: ${m} · ${rows.length} inscrito${rows.length !== 1 ? 's' : ''} en N${nivelIdx}`;
        if (!rows.length) {
            document.getElementById('ndBody').innerHTML = '<div style="text-align:center;padding:2rem;color:var(--text-dim)">Sin inscritos en este nivel para el mes seleccionado.</div>';
            return;
        }
        document.getElementById('ndBody').innerHTML = _renderDrillTable(rows, 'inscritos');
    } catch(e) {
        document.getElementById('ndBody').innerHTML = `<div style="color:#f87171;padding:1rem">Error: ${e.message}</div>`;
    }
}


// ── Helpers de renderizado ───────────────────────────────────────────────────
function _renderDrillTable(rows, tipo) {
    const esInscritos = tipo === 'inscritos';
    const colLabel    = esInscritos ? 'Fecha de Inscripción' : 'Miembro desde';
    let html = `
    <table style="width:100%;border-collapse:collapse;font-size:.82rem;">
        <thead>
            <tr style="color:var(--text-dim);font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;border-bottom:1px solid var(--border);">
                <th style="padding:.5rem .75rem;text-align:left;">#</th>
                <th style="padding:.5rem .75rem;text-align:left;">Nombre Completo</th>
                <th style="padding:.5rem .75rem;text-align:left;">Reg.</th>
                <th style="padding:.5rem .75rem;text-align:left;">${colLabel}</th>
            </tr>
        </thead>
        <tbody>`;
    rows.forEach((r, i) => {
        const nombre = (r.nombre || '') + ' ' + (r.apellido || '');
        const fecha  = r.fecha_inscripcion ? r.fecha_inscripcion.substring(0, 10) : '—';
        const bg     = i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,.02)';
        html += `<tr style="background:${bg};border-bottom:1px solid rgba(255,255,255,.04);">
            <td style="padding:.55rem .75rem;color:var(--text-dim);">${i + 1}</td>
            <td style="padding:.55rem .75rem;color:var(--text-main);font-weight:500;">${nombre.trim() || '—'}</td>
            <td style="padding:.55rem .75rem;color:var(--text-dim);">${r.registro || '—'}</td>
            <td style="padding:.55rem .75rem;color:var(--text-dim);">${fecha}</td>
        </tr>`;
    });
    html += '</tbody></table>';
    return html;
}

function _renderDrillTableCajas(filas) {
    let html = `
    <table style="width:100%;border-collapse:collapse;font-size:.82rem;">
        <thead>
            <tr style="color:var(--text-dim);font-size:.72rem;text-transform:uppercase;letter-spacing:.05em;border-bottom:1px solid var(--border);">
                <th style="padding:.5rem .75rem;text-align:left;">#</th>
                <th style="padding:.5rem .75rem;text-align:left;">Nombre Completo</th>
                <th style="padding:.5rem .75rem;text-align:left;">Reg.</th>
                <th style="padding:.5rem .75rem;text-align:left;">Fecha Compra</th>
                <th style="padding:.5rem .75rem;text-align:right;">Cajas</th>
            </tr>
        </thead>
        <tbody>`;
    const sorted = [...filas].sort((a, b) => (parseFloat(b.cajas) || 0) - (parseFloat(a.cajas) || 0));
    sorted.forEach((v, i) => {
        // comprasMes usa: v.cliente (nombre completo), v.fechaStr (formateada), v.clienteReg
        const nombre = (v.cliente || v.clienteNombre || v.nombre || '').trim() + (v.apellido ? ' ' + v.apellido : '');
        const fecha  = v.fechaStr || (v.fecha || v.fecha_venta || '').toString().substring(0, 10);
        const cajas  = parseFloat(v.cajas || 0).toFixed(1);
        const bg     = i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,.02)';
        html += `<tr style="background:${bg};border-bottom:1px solid rgba(255,255,255,.04);">
            <td style="padding:.55rem .75rem;color:var(--text-dim);">${i + 1}</td>
            <td style="padding:.55rem .75rem;color:var(--text-main);font-weight:500;">${nombre.trim() || '—'}</td>
            <td style="padding:.55rem .75rem;color:var(--text-dim);">${v.clienteReg || v.registro || '—'}</td>
            <td style="padding:.55rem .75rem;color:var(--text-dim);">${fecha || '—'}</td>
            <td style="padding:.55rem .75rem;text-align:right;color:var(--success);font-weight:600;">${cajas}</td>
        </tr>`;
    });
    html += '</tbody></table>';
    return html;
}


/* ============================================================
   AJUSTE MANUAL DE ACTIVOS (Solo Master/Admin)
   Muestra los meses FIFO con saldo individual por mes,
   Asistente de Redes Administradas (Opción 2) y Bitácora Histórica.
   ============================================================ */
async function abrirModalAjusteActivos() {
    // 1. Restricción estricta de seguridad: EXCLUSIVO ROL MASTER
    const esMaster = typeof BO_AUTH !== 'undefined' && BO_AUTH.hasRole && BO_AUTH.hasRole('master');
    if (!esMaster) {
        return BO_AUTH.showAlert('⛔ Acceso restringido: Solo el usuario con Rol Master puede realizar Ajustes Maestros.', 'danger');
    }

    const u = ACTIVOS_USER || CURRENT_USER || {};
    const liderReg = u.registro || u.id;
    if (!liderReg) return BO_AUTH.showAlert('No hay un líder seleccionado para el ajuste.', 'error');
    
    const mesActual = document.getElementById('mesActivosFiltro')?.value || new Date().toISOString().substring(0,7);
    
    // Usuario auditor activo
    const realUser = (typeof _ADMIN_USER_BACKUP !== 'undefined' && _ADMIN_USER_BACKUP)
        ? _ADMIN_USER_BACKUP
        : (typeof CURRENT_USER !== 'undefined' ? CURRENT_USER : (typeof BO_AUTH !== 'undefined' && BO_AUTH.getUser ? BO_AUTH.getUser() : {}));
    const adminNombre = ((realUser?.nombre || 'admin') + ' ' + (realUser?.apellido || realUser?.ape_p || '')).trim() || 'Admin';

    // Obtener detalle FIFO para mostrar saldos por mes
    const fifoDetalle = (window.ACTIVOS_BOLSA_GLOBAL && window.ACTIVOS_BOLSA_GLOBAL.detalleMeses) || [];
    
    // Consultar ajustes existentes por mes y bitácora histórica
    let ajustesExistentes = {};
    let bitacoraRows = [];
    try {
        const [rAj, rBit] = await Promise.all([
            BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: "SELECT mes, SUM(monto) as total FROM activos_transacciones WHERE user_id = " + liderReg + " AND tipo = 'credito_ajuste' GROUP BY mes"
            }),
            BO_API.post('/bo/sql-relay', {
                secret: 'duletia_relay_2026',
                sql: `SELECT id, mes, monto, descripcion, registrado_por, created_at FROM activos_transacciones WHERE user_id = ${liderReg} AND tipo = 'credito_ajuste' ORDER BY created_at DESC LIMIT 10`
            })
        ]);
        (rAj.rows || []).forEach(r => { ajustesExistentes[r.mes] = parseFloat(r.total || 0); });
        bitacoraRows = rBit.rows || [];
    } catch(e) { console.warn('Ajustes/Bitácora query error:', e); }
    
    // Nombres de meses en español
    const mesesEs = ['','Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
    
    // Construir filas por cada mes del FIFO
    let mesRows = '';
    const mesesValidos = [];
    for (const item of fifoDetalle) {
        const [y, m] = item.mes.split('-').map(Number);
        const mesLabel = mesesEs[m] + ' ' + y;
        const gen = Number(item.generadoOriginal || 0);
        const disp = Number(item.disponibleActual || 0);
        const est = item.estatus || 'desconocido';
        const ajExist = ajustesExistentes[item.mes] || 0;
        
        let estatusBadge = '';
        let badgeColor = '';
        if (est === 'disponible') { estatusBadge = '🟢 Disponible'; badgeColor = '#22c55e'; }
        else if (est === 'consumido') { estatusBadge = '🔴 Consumido'; badgeColor = '#ef4444'; }
        else if (est === 'expirado') { estatusBadge = '⚫ Expirado'; badgeColor = '#6b7280'; }
        else if (est === 'pendiente_liberacion') { estatusBadge = '🟡 Pendiente'; badgeColor = '#eab308'; }
        else { estatusBadge = est; badgeColor = '#9ca3af'; }
        
        mesesValidos.push(item.mes);
        
        const ajColor = ajExist < 0 ? '#ef4444' : ajExist > 0 ? '#22c55e' : 'var(--text-dim)';
        const ajDisplay = ajExist !== 0 ? '$' + ajExist.toLocaleString('es-MX', {minimumFractionDigits:2}) : 'Sin ajuste';
        
        mesRows += `
            <div style="display:grid;grid-template-columns:1fr auto 130px;gap:8px;align-items:center;padding:8px 0;border-bottom:1px solid rgba(255,255,255,0.05);">
                <div>
                    <div style="font-weight:600;font-size:0.85rem;color:#fff">${mesLabel}</div>
                    <div style="font-size:0.7rem;color:${badgeColor}">${estatusBadge}</div>
                    <div style="font-size:0.6rem;color:${ajColor};margin-top:2px">Ajuste actual: ${ajDisplay}</div>
                </div>
                <div style="text-align:center;">
                    <div style="font-size:0.65rem;color:var(--text-muted)">Generado</div>
                    <div style="font-size:0.8rem;color:#a78bfa;font-weight:600">$${gen.toLocaleString('es-MX')}</div>
                    <div style="font-size:0.6rem;color:var(--text-dim)">Disp: $${disp.toLocaleString('es-MX')}</div>
                </div>
                <div>
                    <input type="number" class="form-control ajuste-mes-input" data-mes="${item.mes}" data-prev="${ajExist}"
                           style="width:100%;font-size:0.88rem;text-align:center;padding:5px 6px;background:rgba(0,0,0,0.35);border:1px solid rgba(245,158,11,0.4);border-radius:6px;color:#fff;" 
                           placeholder="$0.00" value="${ajExist !== 0 ? ajExist : ''}">
                </div>
            </div>`;
    }
    
    if (!mesRows) {
        mesRows = '<div style="text-align:center;padding:1rem;color:var(--text-dim);font-size:0.8rem">No hay meses FIFO disponibles. Carga primero el Control de Activos de este líder.</div>';
    }

    // Construir tabla de bitácora histórica
    let bitacoraHtml = '';
    if (bitacoraRows.length > 0) {
        bitacoraHtml = `
            <div style="margin-top:16px;background:rgba(0,0,0,0.25);border:1px solid rgba(255,255,255,0.08);border-radius:10px;padding:10px;">
                <div style="font-size:0.75rem;font-weight:700;color:var(--text-main);margin-bottom:6px;display:flex;align-items:center;gap:6px;">
                    <span>📜</span> Bitácora Histórica de Ajustes (${bitacoraRows.length})
                </div>
                <div style="max-height:130px;overflow-y:auto;">
                    <table style="width:100%;border-collapse:collapse;font-size:0.7rem;">
                        <thead>
                            <tr style="color:var(--text-dim);border-bottom:1px solid rgba(255,255,255,0.06);text-align:left;">
                                <th style="padding:4px 6px;">Fecha</th>
                                <th style="padding:4px 6px;">Mes</th>
                                <th style="padding:4px 6px;text-align:right;">Monto</th>
                                <th style="padding:4px 6px;">Motivo</th>
                                <th style="padding:4px 6px;">Operador</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${bitacoraRows.map(b => {
                                const fechaStr = b.created_at ? new Date(b.created_at).toLocaleDateString('es-MX', {day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit'}) : '—';
                                const mNum = parseFloat(b.monto || 0);
                                const mColor = mNum >= 0 ? '#22c55e' : '#ef4444';
                                const mFmt = (mNum >= 0 ? '+' : '') + '$' + mNum.toLocaleString('es-MX', {minimumFractionDigits:2});
                                const autor = b.registrado_por || '<span style="color:var(--text-dim);font-style:italic">Anterior</span>';
                                return `
                                    <tr style="border-bottom:1px solid rgba(255,255,255,0.03);">
                                        <td style="padding:4px 6px;color:var(--text-dim);white-space:nowrap;">${fechaStr}</td>
                                        <td style="padding:4px 6px;font-weight:600;color:#fff;">${b.mes}</td>
                                        <td style="padding:4px 6px;text-align:right;font-weight:700;color:${mColor};">${mFmt}</td>
                                        <td style="padding:4px 6px;color:var(--text-main);max-width:140px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;" title="${(b.descripcion||'').replace(/"/g,'&quot;')}">${b.descripcion || '—'}</td>
                                        <td style="padding:4px 6px;color:#a78bfa;white-space:nowrap;">${autor}</td>
                                    </tr>
                                `;
                            }).join('')}
                        </tbody>
                    </table>
                </div>
            </div>
        `;
    } else {
        bitacoraHtml = `
            <div style="margin-top:14px;background:rgba(0,0,0,0.15);border:1px dashed rgba(255,255,255,0.06);border-radius:8px;padding:8px;text-align:center;font-size:0.72rem;color:var(--text-dim);">
                Sin bitácora de ajustes previos registrados para este líder.
            </div>
        `;
    }
    
    // Create Modal UI
    const modalId = 'modalAjusteBolsa';
    if (document.getElementById(modalId)) document.getElementById(modalId).remove();
    
    const modal = document.createElement('div');
    modal.id = modalId;
    modal.innerHTML = `
        <div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.85);z-index:9999;display:flex;align-items:center;justify-content:center;backdrop-filter:blur(6px);">
            <div style="background:#13151b;border:1px solid rgba(255,255,255,0.12);border-radius:18px;padding:24px;width:94%;max-width:580px;box-shadow:0 24px 48px rgba(0,0,0,0.7);max-height:92vh;overflow-y:auto;">
                <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:12px;">
                    <div>
                        <h3 style="margin:0;color:#fff;font-size:1.25rem;display:flex;align-items:center;gap:8px">
                            <span style="color:#f59e0b">⚡</span> Ajuste Maestro por Mes
                        </h3>
                        <div style="color:var(--text-dim);font-size:0.8rem;margin-top:4px;">
                            Líder: <strong style="color:#fff">${u.nombre||''} (#${liderReg})</strong>
                            <span style="margin-left:8px;background:rgba(245,158,11,0.15);color:#f59e0b;padding:2px 6px;border-radius:6px;font-size:0.68rem;">Auditor: ${adminNombre}</span>
                        </div>
                    </div>
                    <button class="btn btn-sm btn-outline" onclick="document.getElementById('${modalId}').remove()" style="font-size:1rem;padding:2px 8px;border-radius:8px;">✕</button>
                </div>

                <!-- SECCIÓN: ASISTENTE DE RED ADMINISTRADA (OPCIÓN 2) -->
                <div style="margin-bottom:14px;background:rgba(59,130,246,0.06);border:1px solid rgba(59,130,246,0.25);border-radius:12px;padding:12px;">
                    <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;">
                        <span style="font-size:0.8rem;font-weight:700;color:#60a5fa;display:flex;align-items:center;gap:6px;">
                            <span>🤝</span> Asistente de Red Administrada (Opción 2)
                        </span>
                        <span style="font-size:0.65rem;background:rgba(59,130,246,0.2);color:#93c5fd;padding:2px 6px;border-radius:10px;">Acuerdos Especiales</span>
                    </div>
                    <p style="margin:0 0 8px 0;font-size:0.72rem;color:var(--text-dim);line-height:1.3;">
                        Calcula oficialmente la comisión de una red externa que este líder administra (ej. Zenaida / Shaddya) y precarga el Ajuste Maestro con 1 clic.
                    </p>
                    
                    <div style="display:flex;flex-wrap:wrap;gap:6px;align-items:center;margin-bottom:8px;">
                        <span style="font-size:0.7rem;color:var(--text-muted);">Acceso rápido:</span>
                        <button type="button" class="btn btn-xs" id="btnChipShaddya" style="background:rgba(168,85,247,0.18);color:#c084fc;border:1px solid rgba(168,85,247,0.4);border-radius:14px;padding:2px 10px;font-size:0.72rem;cursor:pointer;font-weight:600;">
                            🌟 Shaddya Hernández (#23024)
                        </button>
                    </div>
                    
                    <div style="display:grid;grid-template-columns:1fr 110px auto;gap:8px;align-items:end;">
                        <div class="form-group" style="margin:0;">
                            <label style="display:block;font-size:0.68rem;color:var(--text-muted);margin-bottom:3px;"># Registro Líder Administrado</label>
                            <input type="text" id="araLiderAdminInput" class="form-control" style="width:100%;font-size:0.8rem;padding:5px 8px;background:rgba(0,0,0,0.35);border:1px solid rgba(255,255,255,0.1);color:#fff;border-radius:6px;" placeholder="ej. 23024">
                        </div>
                        <div class="form-group" style="margin:0;">
                            <label style="display:block;font-size:0.68rem;color:var(--text-muted);margin-bottom:3px;">Mes a Liquidar</label>
                            <select id="araMesSelect" class="form-control" style="width:100%;font-size:0.8rem;padding:5px 8px;background:rgba(0,0,0,0.35);border:1px solid rgba(255,255,255,0.1);color:#fff;border-radius:6px;">
                                ${mesesValidos.map(m => `<option value="${m}" ${m === mesActual ? 'selected' : ''}>${m}</option>`).join('')}
                            </select>
                        </div>
                        <div>
                            <button type="button" class="btn btn-primary btn-sm" id="btnAraCalcular" style="font-size:0.75rem;padding:6px 12px;background:#3b82f6;color:#fff;border:none;white-space:nowrap;font-weight:600;border-radius:6px;">
                                ⚡ Calcular Red
                            </button>
                        </div>
                    </div>
                    
                    <div id="araResultadoArea" style="display:none;margin-top:10px;padding:10px;background:rgba(0,0,0,0.3);border-radius:8px;border:1px solid rgba(255,255,255,0.08);"></div>
                </div>
                
                <!-- TABLA DE MESES FIFO -->
                <div style="margin-bottom:12px;background:rgba(0,0,0,0.2);border:1px solid rgba(255,255,255,0.06);border-radius:12px;padding:12px;">
                    <div style="display:grid;grid-template-columns:1fr auto 130px;gap:8px;padding-bottom:6px;border-bottom:1px solid rgba(255,255,255,0.1);margin-bottom:4px;">
                        <div style="font-size:0.68rem;color:var(--text-muted);font-weight:700">MES (FIFO)</div>
                        <div style="font-size:0.68rem;color:var(--text-muted);font-weight:700;text-align:center">SALDOS</div>
                        <div style="font-size:0.68rem;color:var(--text-muted);font-weight:700;text-align:center">AJUSTE ($ MXN)</div>
                    </div>
                    ${mesRows}
                </div>
                
                <div style="text-align:right;font-size:0.82rem;color:var(--text-dim);margin-bottom:12px;">
                    Total ajuste en ventana: <strong id="ajusteTotalPreview" style="color:#f59e0b;font-size:0.95rem;">$0.00</strong>
                </div>
                
                <div style="margin-bottom:14px">
                    <label style="display:block;font-size:0.75rem;color:var(--text-muted);margin-bottom:6px">Motivo / Justificación Operativa (Obligatorio para Auditoría)</label>
                    <input type="text" id="ajusteBolsaMotivo" class="form-control" style="width:100%;background:rgba(0,0,0,0.35);border:1px solid rgba(255,255,255,0.12);color:#fff;border-radius:8px;padding:7px 10px;font-size:0.82rem;" placeholder="ej. Acuerdo Red Administrada: Comisión Shaddya #23024 mes 2026-08">
                </div>

                <div style="margin-bottom:16px;background:rgba(245,158,11,0.06);border:1px solid rgba(245,158,11,0.25);border-radius:10px;padding:12px;">
                    <label style="display:block;font-size:0.75rem;color:#f59e0b;font-weight:700;margin-bottom:6px">🔒 Contraseña / PIN de Autorización Master</label>
                    <input type="password" id="ajusteBolsaPin" class="form-control" style="width:100%;background:rgba(0,0,0,0.35);border:1px solid rgba(245,158,11,0.4);color:#fff;border-radius:8px;padding:7px 10px;font-size:0.85rem;" placeholder="Introduce la clave de autorización Master">
                </div>
                
                <div style="display:flex;gap:10px;justify-content:flex-end;">
                    <button class="btn btn-outline btn-sm" onclick="document.getElementById('${modalId}').remove()">Cancelar</button>
                    <button class="btn btn-primary btn-sm" id="btnConfirmarAjusteBolsa" style="background:#f59e0b;color:#000;border:none;font-weight:700;padding:6px 14px;border-radius:8px;">Guardar Ajustes</button>
                </div>

                <!-- BITÁCORA HISTÓRICA -->
                ${bitacoraHtml}
            </div>
        </div>
    `;
    document.body.appendChild(modal);
    
    // Live preview del total
    const inputs = modal.querySelectorAll('.ajuste-mes-input');
    const previewEl = document.getElementById('ajusteTotalPreview');
    const updatePreview = () => {
        let sum = 0;
        inputs.forEach(i => { const v = parseFloat(i.value); if (!isNaN(v)) sum += v; });
        previewEl.textContent = '$' + sum.toLocaleString('es-MX', {minimumFractionDigits:2});
        previewEl.style.color = sum >= 0 ? '#22c55e' : '#ef4444';
    };
    inputs.forEach(inp => inp.addEventListener('input', updatePreview));
    updatePreview();

    // Chip Shaddya shortcut
    const chipShaddya = document.getElementById('btnChipShaddya');
    if (chipShaddya) {
        chipShaddya.onclick = () => {
            const inp = document.getElementById('araLiderAdminInput');
            if (inp) {
                inp.value = '23024';
                document.getElementById('btnAraCalcular')?.click();
            }
        };
    }

    // Calcular Comisión de Red Administrada
    const btnCalcular = document.getElementById('btnAraCalcular');
    if (btnCalcular) {
        btnCalcular.onclick = async () => {
            const liderBusq = document.getElementById('araLiderAdminInput')?.value.trim();
            const mesSel = document.getElementById('araMesSelect')?.value;
            const resArea = document.getElementById('araResultadoArea');
            if (!liderBusq) return BO_AUTH.showAlert('Ingresa el # de registro del líder a administrar.', 'warning');
            if (!mesSel) return BO_AUTH.showAlert('Selecciona el mes a liquidar.', 'warning');

            btnCalcular.disabled = true;
            btnCalcular.textContent = '⏳ Calculando…';
            resArea.style.display = 'block';
            resArea.innerHTML = '<div style="text-align:center;color:var(--text-dim);font-size:0.75rem;padding:6px;">Consultando red y calculando con motor oficial…</div>';

            try {
                // 1. Obtener datos del líder administrado
                const safeBusq = liderBusq.replace(/'/g, "''");
                const sqlLider = !isNaN(parseInt(liderBusq))
                    ? `SELECT id, registro, nombre, ape_p, galardon, es_empresario_led FROM cliente WHERE registro = ${parseInt(liderBusq)} OR id = '${safeBusq}' LIMIT 1`
                    : `SELECT id, registro, nombre, ape_p, galardon, es_empresario_led FROM cliente WHERE id = '${safeBusq}' OR (nombre || ' ' || COALESCE(ape_p,'')) ILIKE '%${safeBusq}%' LIMIT 1`;
                const rLider = await BO_API.post('/bo/sql-relay', {
                    secret: 'duletia_relay_2026',
                    sql: sqlLider
                });
                const liderAdmin = Array.isArray(rLider) ? rLider[0] : (rLider.rows?.[0] || null);
                if (!liderAdmin) throw new Error(`Líder con registro o ID "${liderBusq}" no encontrado en el sistema.`);

                const liderUUID = liderAdmin.id;
                const liderNom = ((liderAdmin.nombre || '') + ' ' + (liderAdmin.ape_p || '')).trim();
                const esEmpLed = !!liderAdmin.es_empresario_led;
                const galardon = liderAdmin.galardon || 'Plata';

                // 2. Query ventas red para ese mes
                const CAJAS_CALC_EXPR = `COALESCE(
                  (SELECT SUM(
                    CASE
                      WHEN COALESCE(pr.categoria, pr2.categoria) = 'paquete' AND EXISTS (SELECT 1 FROM producto_componente pc2 WHERE pc2.paquete_id = COALESCE(pr.id, pr2.id)) THEN
                        COALESCE((
                          SELECT SUM(
                            CASE WHEN comp_p.comisiona = true
                              THEN COALESCE(comp_p.puntos_equivalencia, 1) * pc.cantidad * (pz.value->>'cantidad')::int
                              ELSE 0
                            END
                          )
                          FROM producto_componente pc
                          JOIN productos comp_p ON comp_p.id = pc.componente_id
                          WHERE pc.paquete_id = COALESCE(pr.id, pr2.id)
                        ), 0)
                      WHEN COALESCE(pr.comisiona, pr2.comisiona) = true THEN
                        COALESCE(COALESCE(pr.puntos_equivalencia, pr2.puntos_equivalencia), 1) * (pz.value->>'cantidad')::int
                      ELSE 0
                    END
                  )
                  FROM jsonb_array_elements(v.piezas::jsonb) pz(value)
                  LEFT JOIN productos pr ON pr.id = (pz.value->>'producto_id')::int
                  LEFT JOIN productos pr2 ON pr.id IS NULL AND pr2.sku = (pz.value->>'sku') AND pr2.activo = true
                  ) / 24.0,
                  v.cantidad
                )`;

                const sqlVentas = `
                    WITH RECURSIVE red AS (
                        SELECT id, 0 AS nivel FROM cliente WHERE id = '${liderUUID}'
                        UNION ALL
                        SELECT c.id, r.nivel + 1 FROM cliente c INNER JOIN red r ON c.patrocinador = r.id WHERE r.nivel < 4
                    )
                    (
                        SELECT v.id, v.total, v.fecha_venta, v.comentario, v.approved, 0 AS nivel,
                               c.registro AS cliente_registro, ${CAJAS_CALC_EXPR} AS cajas_calc
                        FROM venta v JOIN cliente c ON v.cliente_id = c.id
                        WHERE v.cliente_id = '${liderUUID}' AND v.approved = 1 AND TO_CHAR(v.fecha_venta, 'YYYY-MM') = '${mesSel}'
                    ) UNION ALL (
                        SELECT v.id, v.total, v.fecha_venta, v.comentario, v.approved, red.nivel,
                               c.registro AS cliente_registro, ${CAJAS_CALC_EXPR} AS cajas_calc
                        FROM venta v JOIN cliente c ON v.cliente_id = c.id JOIN red ON red.id = v.cliente_id
                        WHERE red.nivel > 0 AND v.approved = 1 AND TO_CHAR(v.fecha_venta, 'YYYY-MM') = '${mesSel}'
                    )
                `;
                const rVentas = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlVentas });
                const ventas = Array.isArray(rVentas) ? rVentas : (rVentas.rows || []);

                // En el Acuerdo de Red Administrada (Opción 2):
                // El líder administrado (ej. Shaddya #23024) entra como Frontal N1 de este líder administrador (ej. Zenaida).
                // Por lo tanto, toda la red se desplaza un nivel:
                // - Nivel 0 de Shaddya (su compra personal) -> Nivel 1 del administrador (20%)
                // - Nivel 1 de Shaddya -> Nivel 2 del administrador (30%)
                // - Nivel 2 de Shaddya -> Nivel 3 del administrador (5%)
                // - Nivel 3 de Shaddya -> Nivel 4 del administrador (5%)
                // - Nivel 4 de Shaddya -> Nivel 5 del administrador (0% fuera de la matriz comisionable)
                const cajasPorNivel = { n1: 0, n2: 0, n3: 0, n4: 0 };
                ventas.forEach(v => {
                    const lvl = parseInt(v.nivel);
                    const cajas = parseFloat(v.cajas_calc || 0);
                    if (lvl === 0) {
                        cajasPorNivel.n1 += cajas; // Compra de Shaddya -> N1 de Zenaida
                    } else if (lvl === 1) {
                        cajasPorNivel.n2 += cajas; // Frontales de Shaddya -> N2 de Zenaida
                    } else if (lvl === 2) {
                        cajasPorNivel.n3 += cajas; // Nietos de Shaddya -> N3 de Zenaida
                    } else if (lvl === 3) {
                        cajasPorNivel.n4 += cajas; // Bisnietos de Shaddya -> N4 de Zenaida
                    }
                    // lvl >= 4 cae en N5+ y no genera comisiones en la matriz de 4 niveles
                });

                const precioCaja = (typeof COMMISSION_CONFIG !== 'undefined' && COMMISSION_CONFIG.precio_caja?.MXN) || 4500;
                // Cálculo matricial oficial desplazado para el administrador:
                // Solo cajas completas comisionan (Math.floor)
                const cN1 = Math.floor(cajasPorNivel.n1 || 0);
                const cN2 = Math.floor(cajasPorNivel.n2 || 0);
                const cN3 = Math.floor(cajasPorNivel.n3 || 0);
                const cN4 = Math.floor(cajasPorNivel.n4 || 0);

                const comN1 = cN1 * precioCaja * 0.20;
                const comN2 = cN2 * precioCaja * 0.30;
                const comN3 = cN3 * precioCaja * 0.05;
                const comN4 = cN4 * precioCaja * 0.05;

                const montoComision = Math.round((comN1 + comN2 + comN3 + comN4) * 100) / 100;
                const totalCajas = cN1 + cN2 + cN3 + cN4;
                const tieneCompraN0 = cN1 >= 1;

                resArea.innerHTML = `
                    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;">
                        <div>
                            <span style="font-weight:700;color:#fff;font-size:0.82rem;">${liderNom}</span>
                            <span style="color:var(--text-dim);font-size:0.72rem;"> (#${liderAdmin.registro})</span>
                            <span style="font-size:0.65rem;background:rgba(168,85,247,0.2);color:#c084fc;padding:1px 6px;border-radius:6px;margin-left:6px;">Red como Frontal N1</span>
                        </div>
                        <span style="font-size:0.7rem;padding:2px 8px;border-radius:8px;background:${tieneCompraN0 ? 'rgba(34,197,94,0.15);color:#4ade80' : 'rgba(239,68,68,0.15);color:#f87171'};font-weight:600;">
                            ${tieneCompraN0 ? '✓ Compra personal (' + cN1 + ' c)' : '⚠ Sin compra personal N0'}
                        </span>
                    </div>
                    <div style="font-size:0.72rem;color:var(--text-muted);display:grid;grid-template-columns:repeat(4,1fr);gap:4px;margin-bottom:8px;text-align:center;">
                        <div style="background:rgba(255,255,255,0.04);padding:4px;border-radius:4px;" title="Compra personal de ${liderNom} (20%)">N1: <strong style="color:#fff">${cN1}</strong> <span style="font-size:0.6rem;color:var(--text-dim)">($${comN1.toLocaleString('es-MX')})</span></div>
                        <div style="background:rgba(255,255,255,0.04);padding:4px;border-radius:4px;" title="Frontales de ${liderNom} (30%)">N2: <strong style="color:#fff">${cN2}</strong> <span style="font-size:0.6rem;color:var(--text-dim)">($${comN2.toLocaleString('es-MX')})</span></div>
                        <div style="background:rgba(255,255,255,0.04);padding:4px;border-radius:4px;" title="Nivel 2 de ${liderNom} (5%)">N3: <strong style="color:#fff">${cN3}</strong> <span style="font-size:0.6rem;color:var(--text-dim)">($${comN3.toLocaleString('es-MX')})</span></div>
                        <div style="background:rgba(255,255,255,0.04);padding:4px;border-radius:4px;" title="Nivel 3 de ${liderNom} (5%)">N4: <strong style="color:#fff">${cN4}</strong> <span style="font-size:0.6rem;color:var(--text-dim)">($${comN4.toLocaleString('es-MX')})</span></div>
                    </div>
                    <div style="display:flex;justify-content:space-between;align-items:center;border-top:1px solid rgba(255,255,255,0.08);padding-top:8px;">
                        <div>
                            <div style="font-size:0.68rem;color:var(--text-dim)">Comisión calculada (${mesSel}) · ${totalCajas} cajas:</div>
                            <div style="font-size:1.15rem;font-weight:800;color:#22c55e;">$${montoComision.toLocaleString('es-MX', {minimumFractionDigits:2})} MXN</div>
                        </div>
                        <button type="button" class="btn btn-sm" id="btnAraCargarTabla" style="background:#22c55e;color:#000;border:none;font-weight:700;font-size:0.75rem;padding:6px 12px;border-radius:6px;cursor:pointer;">
                            ➕ Cargar a ${mesSel}
                        </button>
                    </div>
                `;

                const btnCargar = document.getElementById('btnAraCargarTabla');
                if (btnCargar) {
                    btnCargar.onclick = () => {
                        const targetInput = modal.querySelector(`.ajuste-mes-input[data-mes="${mesSel}"]`);
                        if (targetInput) {
                            targetInput.value = montoComision;
                            targetInput.style.borderColor = '#22c55e';
                            targetInput.style.background = 'rgba(34,197,94,0.1)';
                            updatePreview();

                            const motivoInput = document.getElementById('ajusteBolsaMotivo');
                            if (motivoInput) {
                                motivoInput.value = `Acuerdo Red Administrada (Opción 2): Comisión red ${liderNom} (#${liderAdmin.registro}) mes ${mesSel} [Autorizado por: ${adminNombre}]`;
                            }
                            BO_AUTH.showAlert(`✓ Comisión de $${montoComision.toLocaleString('es-MX', {minimumFractionDigits:2})} cargada al mes ${mesSel}. Revisa y haz clic en "Guardar Ajustes".`, 'success');
                        } else {
                            BO_AUTH.showAlert(`El mes ${mesSel} no está dentro de la ventana FIFO visible del líder.`, 'warning');
                        }
                    };
                }

            } catch(err) {
                resArea.innerHTML = `<div style="color:#ef4444;font-size:0.75rem;padding:4px;">Error: ${err.message}</div>`;
            } finally {
                btnCalcular.disabled = false;
                btnCalcular.textContent = '⚡ Calcular Red';
            }
        };
    }
    
    // Guardar Ajustes con trazabilidad y auditor
    document.getElementById('btnConfirmarAjusteBolsa').onclick = async () => {
        const motivo = document.getElementById('ajusteBolsaMotivo').value.trim();
        if (!motivo) return BO_AUTH.showAlert('Debes especificar un motivo para la bitácora operativa.', 'warning');
        
        const pin = document.getElementById('ajusteBolsaPin')?.value.trim();
        if (pin !== 'pitomaestro') {
            return BO_AUTH.showAlert('⛔ PIN o Contraseña Master incorrecta. Autorización denegada.', 'danger');
        }
        
        // Recolectar ajustes que cambiaron vs los existentes
        const cambios = [];
        inputs.forEach(inp => {
            const monto = parseFloat(inp.value) || 0;
            const prev = parseFloat(inp.dataset.prev) || 0;
            if (monto !== prev) {
                cambios.push({ mes: inp.dataset.mes, monto });
            }
        });
        
        if (cambios.length === 0) return BO_AUTH.showAlert('No hay cambios en los ajustes.', 'warning');
        
        const resumen = cambios.map(a => a.mes + ': $' + a.monto.toLocaleString('es-MX') + (a.monto === 0 ? ' (eliminar)' : '')).join('\n');
        if (!confirm(`¿CONFIRMAS estos ajustes para #${liderReg}?\n\n${resumen}\n\nMotivo: ${motivo}\nRegistrado por: ${adminNombre}`)) return;
        
        try {
            document.getElementById('btnConfirmarAjusteBolsa').disabled = true;
            document.getElementById('btnConfirmarAjusteBolsa').textContent = 'Procesando...';
            
            const safeMotivo = motivo.replace(/'/g, "''");
            const safeAutor = adminNombre.replace(/'/g, "''");
            
            // Para cada mes con cambio: borrar anterior e insertar nuevo con registrado_por
            for (const aj of cambios) {
                // Borrar ajustes anteriores de este mes específico
                await BO_API.post('/bo/sql-relay', {
                    secret: 'duletia_relay_2026',
                    sql: `DELETE FROM activos_transacciones WHERE user_id = ${liderReg} AND mes = '${aj.mes}' AND tipo = 'credito_ajuste'`
                });
                // Insertar nuevo (solo si no es 0)
                if (aj.monto !== 0) {
                    const query = `INSERT INTO activos_transacciones (user_id, mes, monto, tipo, descripcion, registrado_por, created_at) VALUES (${liderReg}, '${aj.mes}', ${aj.monto}, 'credito_ajuste', '${safeMotivo}', '${safeAutor}', NOW()) RETURNING id`;
                    await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: query });
                }
            }
            
            BO_AUTH.showAlert(`¡${cambios.length} ajuste(s) guardados con éxito por ${adminNombre}! Recalculando...`, 'success');
            document.getElementById(modalId).remove();
            
            // Refresh
            if (typeof loadActivos === 'function') loadActivos();
            
        } catch(e) {
            BO_AUTH.showAlert('Error al aplicar ajuste: ' + e.message, 'error');
            document.getElementById('btnConfirmarAjusteBolsa').disabled = false;
            document.getElementById('btnConfirmarAjusteBolsa').textContent = 'Guardar Ajustes';
        }
    };
}


// ══ CSV Activos Global — Descarga CSV con líderes que generaron (solo master/admin) ══════
async function exportarCsvActivosGlobal() {
    if (!isAdminOrMaster()) return BO_AUTH.showAlert('Solo Administradores pueden exportar este CSV.', 'error');
    
    const mesStr = document.getElementById('mesActivosFiltro')?.value || new Date().toISOString().substring(0,7);
    const btn = document.getElementById('btnCsvActivosGlobal');
    const btnText = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = '⏳ Generando...'; btn.disabled = true; }
    
    try {
        // Obtener mes real del sistema para FIFO
        const nowReal = new Date();
        const mesRealActual = nowReal.getFullYear() + '-' + String(nowReal.getMonth() + 1).padStart(2, '0');
        
        // ── PASO 0: Generar los meses del ledger (desde 2026-03 a M-0) ANTES de todo ──
        const [yReal, mReal] = mesRealActual.split('-').map(Number);
        const _numMesesLedger = Math.max(4, (yReal - 2026) * 12 + (mReal - 3));
        const mesesLedger = [];
        for (let i = _numMesesLedger; i >= 0; i--) {
            const d = new Date(yReal, mReal - 1, 1); d.setMonth(d.getMonth() - i);
            mesesLedger.push(d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0'));
        }
        const mesesIn = mesesLedger.map(m => "'" + m + "'").join(',');
        
        // ── PASO 1: Config de comisiones y cierre de activos ──
        const sqlConfig = "SELECT clave, valor FROM sistema_config WHERE clave IN ('comisiones', 'cierre_activos_config')";
        const rConfig = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlConfig });
        let comisionesConfig = {};
        let cierreConfig = {};
        for (const row of (rConfig.rows || [])) {
            if (row.clave === 'comisiones') comisionesConfig = row.valor || {};
            if (row.clave === 'cierre_activos_config') {
                cierreConfig = typeof row.valor === 'string' ? JSON.parse(row.valor) : (row.valor || {});
            }
        }
        const preciosCaja = comisionesConfig.precio_caja || {};
        const umbralesLed = comisionesConfig.umbral_empresario_led || {};
        const _uLibBolsa = cierreConfig.ultimo_mes_liberado || window._cierreActivosConfig?.ultimo_mes_liberado || '2026-07';

        // ── PASO 2: Query BOTTOM-UP — partimos de ventas reales y subimos la cadena ──
        // En vez de crear un árbol recursivo desde 40k clientes (top-down),
        // partimos de las ventas que existen y subimos por patrocinador hasta 4 niveles.
        // Así el CTE solo toca registros con actividad real (~5k líderes).
        const sqlVentas = `
            WITH RECURSIVE
            ventas_periodo AS (
                SELECT v.id AS venta_id, v.cliente_id, TO_CHAR(v.fecha_venta, 'YYYY-MM') AS mes,
                       COALESCE(
                         (SELECT SUM(
                           CASE
                             WHEN COALESCE(pr.categoria, pr2.categoria) = 'paquete' AND EXISTS (SELECT 1 FROM producto_componente pc2 WHERE pc2.paquete_id = COALESCE(pr.id, pr2.id)) THEN
                               COALESCE((
                                 SELECT SUM(
                                   CASE WHEN comp_p.comisiona = true
                                     THEN COALESCE(comp_p.puntos_equivalencia, 1) * pc.cantidad * (pz.value->>'cantidad')::int
                                     ELSE 0
                                   END
                                 )
                                 FROM producto_componente pc
                                 JOIN productos comp_p ON comp_p.id = pc.componente_id
                                 WHERE pc.paquete_id = COALESCE(pr.id, pr2.id)
                               ), 0)
                             WHEN COALESCE(pr.comisiona, pr2.comisiona) = true THEN
                               COALESCE(COALESCE(pr.puntos_equivalencia, pr2.puntos_equivalencia), 1) * (pz.value->>'cantidad')::int
                             ELSE 0
                           END
                         )
                         FROM jsonb_array_elements(v.piezas::jsonb) pz(value)
                         LEFT JOIN productos pr ON pr.id = (pz.value->>'producto_id')::int
                         LEFT JOIN productos pr2 ON pr.id IS NULL AND pr2.sku = (pz.value->>'sku') AND pr2.activo = true
                         ) / 24.0,
                         v.cantidad
                       ) AS cajas_calc
                FROM venta v
                WHERE v.approved = 1 AND TO_CHAR(v.fecha_venta, 'YYYY-MM') IN (${mesesIn})
            ),
            cadena_arriba AS (
                SELECT vp.cliente_id AS comprador_id, vp.mes, vp.cajas_calc,
                       c.id AS cur_id, c.registro AS cur_reg, c.patrocinador AS parent_id, 0 AS nivel
                FROM ventas_periodo vp
                JOIN cliente c ON c.id = vp.cliente_id
                UNION ALL
                SELECT ca.comprador_id, ca.mes, ca.cajas_calc,
                       padre.id, padre.registro, padre.patrocinador, ca.nivel + 1
                FROM cadena_arriba ca
                JOIN cliente padre ON padre.id = ca.parent_id
                WHERE ca.nivel < 4 AND ca.parent_id IS NOT NULL
            )
            SELECT cur_reg AS lider_reg, nivel, mes,
                   COALESCE(SUM(cajas_calc), 0) AS cajas
            FROM cadena_arriba
            GROUP BY cur_reg, nivel, mes
        `;
        const rVentas = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlVentas });
        
        // Indexar ventas: { liderReg: { mes: { n0, n1, n2, n3, n4 } } }
        const ventasIndex = {};
        for (const row of (rVentas.rows || [])) {
            const reg = String(row.lider_reg);
            if (!ventasIndex[reg]) ventasIndex[reg] = {};
            if (!ventasIndex[reg][row.mes]) ventasIndex[reg][row.mes] = { n0:0, n1:0, n2:0, n3:0, n4:0, n1_activos:0 };
            const nivel = parseInt(row.nivel);
            if (nivel >= 0 && nivel <= 4) ventasIndex[reg][row.mes]['n'+nivel] = parseFloat(row.cajas) || 0;
        }
        
        // ── PASO 3: Recoger registros únicos que generaron actividad en su cadena ──
        // El CTE bottom-up solo produce registros con ventas reales, todos son relevantes
        const regsConActividad = new Set(Object.keys(ventasIndex));
        
        if (regsConActividad.size === 0) {
            BO_AUTH.showAlert('No se encontraron líderes con actividad en la cadena.', 'warning');
            if (btn) { btn.innerHTML = btnText; btn.disabled = false; }
            return;
        }
        
        // ── PASO 4: Metadata SOLO de líderes que generaron (~5k en vez de 40k) ──
        const regsIn = [...regsConActividad].map(r => "'" + r + "'").join(',');
        const sqlLideres = `
            SELECT c.registro, c.nombre, c.ape_p, c.galardon, c.es_empresario_led,
                   COALESCE(p.codigo, 'MEX') AS pais_codigo,
                   CASE COALESCE(p.codigo,'MEX')
                     WHEN 'SLV' THEN 'USD' WHEN 'GTM' THEN 'USD' WHEN 'GTQ' THEN 'USD'
                     WHEN 'USA' THEN 'USD' WHEN 'CAN' THEN 'CAD' ELSE 'MXN'
                   END AS moneda_codigo,
                   CASE COALESCE(p.codigo,'MEX')
                     WHEN 'SLV' THEN 'SLV_USD' WHEN 'GTM' THEN 'SLV_USD' WHEN 'GTQ' THEN 'SLV_USD'
                     WHEN 'USA' THEN 'USD' WHEN 'CAN' THEN 'CAD' ELSE 'MXN'
                   END AS cfg_key
            FROM cliente c
            LEFT JOIN pais p ON c.pais_id = p.id
            WHERE c.registro IN (${regsIn})
            ORDER BY c.nombre, c.ape_p
        `;
        const rLideres = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlLideres });
        
        // ── PASO 5: N1 activos (solo de líderes que generaron) ──
        const sqlN1 = `
            SELECT pat.registro AS lider_reg, TO_CHAR(v.fecha_venta, 'YYYY-MM') AS mes,
                   COUNT(DISTINCT hijo.registro) AS n1_activos
            FROM cliente pat
            JOIN cliente hijo ON hijo.patrocinador = pat.id
            JOIN venta v ON v.cliente_id = hijo.id AND v.approved = 1
            WHERE TO_CHAR(v.fecha_venta, 'YYYY-MM') IN (${mesesIn})
              AND pat.registro IN (${regsIn})
            GROUP BY pat.registro, mes
        `;
        const rN1 = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlN1 });
        for (const row of (rN1.rows || [])) {
            const reg = String(row.lider_reg);
            if (!ventasIndex[reg]) ventasIndex[reg] = {};
            if (!ventasIndex[reg][row.mes]) ventasIndex[reg][row.mes] = { n0:0, n1:0, n2:0, n3:0, n4:0, n1_activos:0 };
            ventasIndex[reg][row.mes].n1_activos = parseInt(row.n1_activos) || 0;
        }
        
        // ── PASO 6: Débitos y ajustes por líder+mes ──
        const sqlDebitos = `
            SELECT user_id, mes, COALESCE(SUM(monto),0) AS total
            FROM activos_transacciones
            WHERE tipo = 'debito' AND mes IN (${mesesIn})
            GROUP BY user_id, mes
        `;
        const sqlAjustes = `
            SELECT user_id, mes, COALESCE(SUM(monto),0) AS total
            FROM activos_transacciones
            WHERE tipo = 'credito_ajuste' AND mes IN (${mesesIn})
            GROUP BY user_id, mes
        `;
        const sqlGastoHist = `
            SELECT user_id, COALESCE(SUM(monto),0) AS total
            FROM activos_transacciones
            WHERE tipo = 'debito'
            GROUP BY user_id
        `;
        const [rDebitos, rAjustes, rGastoHist] = await Promise.all([
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlDebitos }),
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlAjustes }),
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlGastoHist })
        ]);
        
        // Indexar débitos
        const debitosIndex = {};
        for (const row of (rDebitos.rows || [])) {
            const reg = String(row.user_id);
            if (!debitosIndex[reg]) debitosIndex[reg] = {};
            debitosIndex[reg][row.mes] = parseFloat(row.total) || 0;
        }
        // Indexar ajustes
        const ajustesIndex = {};
        for (const row of (rAjustes.rows || [])) {
            const reg = String(row.user_id);
            if (!ajustesIndex[reg]) ajustesIndex[reg] = {};
            ajustesIndex[reg][row.mes] = parseFloat(row.total) || 0;
        }
        // Indexar gasto histórico
        const gastoHistIndex = {};
        for (const row of (rGastoHist.rows || [])) {
            gastoHistIndex[String(row.user_id)] = parseFloat(row.total) || 0;
        }
        
        // ── PASO 7: Iterar SOLO líderes que generaron y calcular FIFO ──
        const csvRows = [];
        for (const lider of (rLideres.rows || [])) {
            const reg = String(lider.registro);
            const nombre = ((lider.nombre || '') + ' ' + (lider.ape_p || '')).trim();
            const moneda = lider.moneda_codigo || 'MXN';
            const cfgKey = lider.cfg_key || 'MXN';
            const pbox = parseFloat(preciosCaja[cfgKey]) || 4500;
            const umbralLed = parseFloat(umbralesLed[cfgKey]) || 10000;
            const galardon = (lider.galardon || '').toLowerCase();
            const esLed = lider.es_empresario_led === true;
            
            const liderVentas = ventasIndex[reg] || {};
            const liderDebitos = debitosIndex[reg] || {};
            const liderAjustes = ajustesIndex[reg] || {};
            const gastoHist = gastoHistIndex[reg] || 0;
            
            // Construir historial bolsa (M-4 a M-0)
            const historialBolsa = [];
            let generadoMesFiltro = 0;
            let gastosMesFiltro = 0;
            let ajusteMesFiltro = 0;
            let flagMes = 'OK';
            
            for (const mIt of mesesLedger) {
                const mv = liderVentas[mIt] || { n0:0, n1:0, n2:0, n3:0, n4:0, n1_activos:0 };
                const compro = mv.n0 > 0;
                const n1Act = mv.n1_activos || 0;
                
                // calcularPlanDulet con pbox y umbral correctos
                const brutoN1 = Math.floor(mv.n1) * pbox * 0.20;
                const brutoN2 = Math.floor(mv.n2) * pbox * 0.30;
                const brutoN3 = Math.floor(mv.n3) * pbox * 0.05;
                const brutoN4 = Math.floor(mv.n4) * pbox * 0.05;
                const totalBruto = brutoN1 + brutoN2 + brutoN3 + brutoN4;
                
                let finalCalc = 0;
                let nTipo = 'ok';
                let minReq = 0;
                if (!compro) {
                    finalCalc = 0;
                    nTipo = 'noderecho';
                } else {
                    if (esLed || totalBruto >= umbralLed) minReq = 5;
                    if (galardon === 'plata' || galardon === 'platino') minReq = Math.max(minReq, 10);
                    else if (galardon === 'oro' || galardon === 'perla' || galardon === 'perla negra') minReq = Math.max(minReq, 20);
                    else if (galardon === 'diamante') minReq = Math.max(minReq, 25);
                    
                    if (minReq === 0 || n1Act >= minReq) {
                        finalCalc = totalBruto;
                    } else {
                        const fN1 = brutoN1;
                        const fN2 = Math.min(Math.floor(mv.n2), n1Act) * pbox * 0.30;
                        finalCalc = fN1 + fN2;
                        nTipo = 'frontales';
                    }
                }
                
                // Ajuste maestro
                const ajuste = liderAjustes[mIt] || 0;
                const genConAjuste = Math.max(0, finalCalc + ajuste);
                
                historialBolsa.push({ mes: mIt, generado: genConAjuste, generadoOriginal: finalCalc, ajusteMaestro: Math.abs(ajuste), compro });
                
                // Datos del mes filtro específico
                if (mIt === mesStr) {
                    generadoMesFiltro = genConAjuste;
                    gastosMesFiltro = liderDebitos[mIt] || 0;
                    ajusteMesFiltro = Math.abs(ajuste);
                    if (!compro) flagMes = 'SIN DERECHO A ACTIVOS';
                    else if (nTipo === 'frontales') flagMes = 'Necesitas ' + minReq + ' frontales directos para cobrar la totalidad de tu cadena (tienes ' + n1Act + ').';
                    else flagMes = 'OK';
                }
            }
            
            // FIFO
            const bolsa = (typeof calcularBolsaGlobal === 'function')
                ? calcularBolsaGlobal(historialBolsa, gastoHist, mesRealActual, liderDebitos, mesRealActual, _uLibBolsa)
                : { saldoDisponible: 0, detalleMeses: [] };
            
            // Recoger datos de los meses visibles (los 5 meses de la tabla de auditoría, ej. desde Mayo)
            const mesesVisibles = mesesLedger.slice(-5);
            const rowData = {
                id: reg,
                nombre: nombre,
                moneda: moneda,
                flag: flagMes,
                mesesData: {},
                remanenteVerde: bolsa.saldoDisponible.toFixed(2)
            };
            for (const mVis of mesesVisibles) {
                const dM = (bolsa.detalleMeses || []).find(x => x.mes === mVis);
                rowData.mesesData[mVis] = {
                    generado: (dM ? dM.generado : 0).toFixed(2),
                    gastado: (dM ? dM.consumidoFIFO : 0).toFixed(2)
                };
            }
            csvRows.push(rowData);
        }
        
        // ── PASO 8: Generar CSV ──
        const mesesVisibles = mesesLedger.slice(-5);
        const NOMBRES_MESES_TXT = ['', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        function fmtNombreMesCol(mStr) {
            const [y, m] = mStr.split('-').map(Number);
            return `${NOMBRES_MESES_TXT[m] || mStr} ${y}`;
        }

        let headerCols = ['ID', 'NOMBRE COMPLETO', 'MONEDA', 'SITUACION(FLAG)'];
        for (const mVis of mesesVisibles) {
            const nomM = fmtNombreMesCol(mVis);
            headerCols.push(`${nomM} Generado`);
            headerCols.push(`${nomM} Gastado`);
        }
        headerCols.push('REMANENTE(numero verde)');

        let csv = headerCols.map(h => `"${h}"`).join(',') + '\n';
        for (const r of csvRows) {
            const escNombre = (r.nombre || '').replace(/"/g, '""');
            const escFlag = (r.flag || '').replace(/"/g, '""');
            let cols = [r.id, `"${escNombre}"`, `"${r.moneda}"`, `"${escFlag}"`];
            for (const mVis of mesesVisibles) {
                const md = r.mesesData[mVis] || { generado: '0.00', gastado: '0.00' };
                cols.push(md.generado);
                cols.push(md.gastado);
            }
            cols.push(r.remanenteVerde);
            csv += cols.join(',') + '\n';
        }
        
        const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `activos_global_${mesStr}.csv`;
        a.click();
        
        BO_AUTH.showAlert(`✓ CSV exportado: ${csvRows.length} líderes con actividad — ${mesStr}`, 'success');
    } catch (e) {
        console.error('Error exportando CSV Activos Global:', e);
        BO_AUTH.showAlert('Error generando CSV: ' + e.message, 'error');
    } finally {
        if (btn) { btn.innerHTML = btnText; btn.disabled = false; }
    }
}


async function abrirModalReporteActivos(mesParam = null) {
    if (!isAdminOrMaster()) return BO_AUTH.showAlert('Solo Administradores pueden ver este reporte.', 'error');
    if (!ACTIVOS_USER && (!CURRENT_USER || parseInt(CURRENT_USER.rol_id?.slice(-1)||0) < 3)) {
        return BO_AUTH.showAlert('Selecciona un usuario primero.', 'warning');
    }
    
    const u = ACTIVOS_USER || CURRENT_USER;
    const liderReg = u.registro;
    const mesStr = mesParam || document.getElementById('mesActivosFiltro')?.value || new Date().toISOString().substring(0,7);
    
    const modalId = 'modalReporteActivos';
    if (document.getElementById(modalId)) document.getElementById(modalId).remove();
    
    const globalLedger = window.ACTIVOS_BOLSA_GLOBAL || { saldoDisponible: 0, detalleMeses: [] };
    const detalleMeses = globalLedger.detalleMeses || [];
    const mesesVigentes = detalleMeses.filter(d => d.estatus !== 'expirado' && d.estatus !== 'pendiente_liberacion').map(d => d.mes);
    
    const modal = document.createElement('div');
    modal.id = modalId;
    modal.innerHTML = `
        <div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.85);z-index:9999;display:flex;align-items:center;justify-content:center;backdrop-filter:blur(6px);">
            <div style="background:#18181b;border:1px solid rgba(255,255,255,0.1);border-radius:16px;padding:26px;width:95%;max-width:940px;box-shadow:0 25px 50px rgba(0,0,0,0.6);max-height:92vh;overflow-y:auto;display:flex;flex-direction:column;gap:16px">
                <div style="display:flex;justify-content:space-between;align-items:center;border-bottom:2px solid rgba(99,102,241,0.3);padding-bottom:12px">
                    <div>
                        <h3 style="margin:0;color:#fff;font-size:1.25rem;letter-spacing:-0.3px;display:flex;align-items:center;gap:8px">
                            📊 Reporte de Activos: <strong>${u.nombre||''}</strong> <span style="font-size:0.85rem;color:#818cf8;background:rgba(99,102,241,0.15);padding:2px 8px;border-radius:6px;font-family:monospace">#${liderReg}</span>
                        </h3>
                        <div style="font-size:0.75rem;color:var(--text-dim);margin-top:3px">
                            Auditoría de generación, ajustes y consumos aplicados (Regla FIFO de 90 días)
                        </div>
                    </div>
                    <button class="btn btn-sm btn-outline" onclick="document.getElementById('${modalId}').remove()" style="border-color:rgba(255,255,255,0.2);color:#fff">✕ Cerrar</button>
                </div>
                
                <!-- RESUMEN GLOBAL -->
                <div style="display:grid;grid-template-columns:1fr 1fr;gap:15px">
                    <div style="background:linear-gradient(135deg,rgba(0,0,0,0.3),rgba(0,0,0,0.15));border:1px solid rgba(255,255,255,0.06);border-radius:12px;padding:16px;">
                        <h4 style="margin:0 0 12px 0;color:var(--text-muted);font-size:0.8rem;text-transform:uppercase;letter-spacing:0.5px">💰 Resumen Global (FIFO)</h4>
                        <div style="display:flex;justify-content:space-between;margin-bottom:8px;padding:6px 0">
                            <span style="color:var(--text-dim);font-size:0.82rem">Generado Vigente:</span>
                            <span style="color:#22c55e;font-weight:700;font-size:0.85rem">$${(detalleMeses.filter(d=>d.estatus!=='expirado'&&d.estatus!=='pendiente_liberacion').reduce((s,d)=>s+(d.generado||Math.max(0, d.generadoOriginal-(d.ajusteMaestro||0))),0)).toLocaleString('es-MX',{minimumFractionDigits:2})}</span>
                        </div>
                        <div style="display:flex;justify-content:space-between;margin-bottom:8px;padding:6px 0">
                            <span style="color:var(--text-dim);font-size:0.82rem">Consumido Total:</span>
                            <span style="color:#ef4444;font-weight:700;font-size:0.85rem">$${(detalleMeses.filter(d=>d.estatus!=='expirado'&&d.estatus!=='pendiente_liberacion').reduce((s,d)=>s+d.consumidoFIFO,0)).toLocaleString('es-MX',{minimumFractionDigits:2})}</span>
                        </div>
                        <div style="display:flex;justify-content:space-between;padding:8px 0 0 0;border-top:1px solid rgba(255,255,255,0.12)">
                            <span style="color:#fff;font-size:0.9rem;font-weight:700">Saldo Billetera:</span>
                            <span style="color:#fcd34d;font-weight:700;font-size:0.95rem">$${(globalLedger.saldoDisponible).toLocaleString('es-MX',{minimumFractionDigits:2})}</span>
                        </div>
                    </div>
                    
                    <div style="background:linear-gradient(135deg,rgba(0,0,0,0.3),rgba(0,0,0,0.15));border:1px solid rgba(255,255,255,0.06);border-radius:12px;padding:16px;overflow-y:auto;max-height:200px">
                        <h4 style="margin:0 0 12px 0;color:var(--text-muted);font-size:0.8rem;text-transform:uppercase;letter-spacing:0.5px">⚡ Historial de Ajustes</h4>
                        <div id="rep-ajustes-content" style="font-size:0.75rem;color:var(--text-dim)">Cargando...</div>
                    </div>
                </div>
                
                <!-- TABLA DE CONSUMOS / RETIROS -->
                <div style="background:linear-gradient(135deg,rgba(0,0,0,0.3),rgba(0,0,0,0.15));border:1px solid rgba(255,255,255,0.06);border-radius:12px;padding:18px;flex:1;overflow-y:auto;max-height:460px">
                    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;flex-wrap:wrap;gap:8px">
                        <h4 style="margin:0;color:var(--text-muted);font-size:0.8rem;text-transform:uppercase;letter-spacing:0.5px">💳 Detalle de Consumos y Retiros</h4>
                        <div id="rep-tabs-filtros" style="display:flex;gap:6px;flex-wrap:wrap">
                            <!-- Botones inyectados dinámicamente -->
                        </div>
                    </div>
                    
                    <!-- BANNER EXPLICATIVO FIFO (si aplica) -->
                    <div id="rep-banner-fifo" style="display:none;margin-bottom:14px"></div>
                    
                    <table style="width:100%;font-size:0.78rem;color:var(--text-dim);border-collapse:separate;border-spacing:0">
                        <thead>
                            <tr style="background:rgba(99,102,241,0.12)">
                                <th style="text-align:left;padding:8px 10px;color:#a5b4fc;font-weight:600;font-size:0.72rem;text-transform:uppercase;letter-spacing:0.3px;border-bottom:2px solid rgba(99,102,241,0.25);border-radius:6px 0 0 0">FECHA</th>
                                <th style="text-align:center;padding:8px 10px;color:#a5b4fc;font-weight:600;font-size:0.72rem;text-transform:uppercase;letter-spacing:0.3px;border-bottom:2px solid rgba(99,102,241,0.25)">MES CONT.</th>
                                <th style="text-align:center;padding:8px 10px;color:#a5b4fc;font-weight:600;font-size:0.72rem;text-transform:uppercase;letter-spacing:0.3px;border-bottom:2px solid rgba(99,102,241,0.25)">TIPO</th>
                                <th style="text-align:left;padding:8px 10px;color:#a5b4fc;font-weight:600;font-size:0.72rem;text-transform:uppercase;letter-spacing:0.3px;border-bottom:2px solid rgba(99,102,241,0.25)">BENEFICIARIO</th>
                                <th style="text-align:left;padding:8px 10px;color:#a5b4fc;font-weight:600;font-size:0.72rem;text-transform:uppercase;letter-spacing:0.3px;border-bottom:2px solid rgba(99,102,241,0.25)">CONCEPTO / NOTA</th>
                                <th style="text-align:right;padding:8px 10px;color:#a5b4fc;font-weight:600;font-size:0.72rem;text-transform:uppercase;letter-spacing:0.3px;border-bottom:2px solid rgba(99,102,241,0.25);border-radius:0 6px 0 0">MONTO</th>
                            </tr>
                        </thead>
                        <tbody id="rep-ventas-content">
                            <tr><td colspan="6" style="text-align:center;padding:20px;color:var(--text-dim)">⏳ Cargando datos...</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
    
    try {
        // Query TODOS los débitos del usuario + TODOS los ajustes
        const queryVentas = "SELECT id, venta_id, monto, mes, descripcion, TO_CHAR(created_at, 'YYYY-MM-DD HH24:MI:SS') as fecha FROM activos_transacciones WHERE user_id = " + liderReg + " AND tipo = 'debito' ORDER BY mes DESC, created_at DESC";
        const queryAjustes = "SELECT monto, mes, descripcion, TO_CHAR(created_at, 'YYYY-MM-DD HH24:MI:SS') as fecha FROM activos_transacciones WHERE user_id = " + liderReg + " AND tipo = 'credito_ajuste' ORDER BY mes DESC, created_at DESC";
        
        const [rVentas, rAjustes] = await Promise.all([
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: queryVentas }),
            BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: queryAjustes })
        ]);

        const todosDebitos = rVentas.rows || [];
        const todosAjustes = rAjustes.rows || [];

        // Buscar nombres de beneficiarios TERCERO
        const clienteIds = [...new Set(
            todosDebitos
                .map(r => { const m = (r.descripcion||'').match(/para #(\d+)/); return m ? parseInt(m[1]) : null; })
                .filter(Boolean)
        )];
        let nombreMap = {};
        if (clienteIds.length > 0) {
            try {
                const sqlNombres = `SELECT registro::text AS registro, nombre, COALESCE(ape_p,'') AS apellido FROM cliente WHERE registro::text IN (${clienteIds.map(id => `'${id}'`).join(',')})`;
                const rNombres = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql: sqlNombres });
                (rNombres?.rows || []).forEach(cl => {
                    nombreMap[String(cl.registro)] = (cl.nombre + ' ' + (cl.apellido || '')).trim();
                });
            } catch(e) { console.warn('nombres error:', e); }
        }

        // Renderizar Historial de Ajustes
        const divAjustes = document.getElementById('rep-ajustes-content');
        if (!todosAjustes.length) {
            divAjustes.innerHTML = '<span style="color:var(--text-dim);font-style:italic">Sin ajustes maestros registrados.</span>';
        } else {
            divAjustes.innerHTML = todosAjustes.map(r => {
                const esMesActual = r.mes === mesStr;
                const bgAj = esMesActual ? 'rgba(245,158,11,0.08)' : 'transparent';
                const bordeAj = esMesActual ? '1px solid rgba(245,158,11,0.2)' : '1px dashed rgba(255,255,255,0.06)';
                return `
                <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:6px;padding:6px 8px;border-radius:6px;background:${bgAj};border-bottom:${bordeAj}">
                    <div style="display:flex;align-items:center;gap:6px">
                        <span style="color:${esMesActual ? '#f59e0b' : '#a5b4fc'};font-weight:700;font-size:0.78rem">$${parseFloat(r.monto||0).toLocaleString('es-MX',{minimumFractionDigits:2})}</span>
                        <span style="font-size:0.6rem;color:var(--text-dim);background:rgba(255,255,255,0.06);padding:1px 5px;border-radius:3px">${r.mes || (r.fecha||'').substring(0,7)}</span>
                    </div>
                    <div style="text-align:right;max-width:55%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:0.7rem" title="${r.descripcion}">${r.descripcion}</div>
                </div>`;
            }).join('');
        }

        // Determinar consumos vigentes y totales
        const debitosVigentes = todosDebitos.filter(r => mesesVigentes.includes(r.mes));
        const totalVigente = debitosVigentes.reduce((s, r) => s + parseFloat(r.monto||0), 0);
        const mesesConDebitos = [...new Set(todosDebitos.map(r => r.mes))].sort().reverse();

        // Filtro activo inicial
        const divTabs = document.getElementById('rep-tabs-filtros');
        let filtroActivo = 'vigente';
        
        // Si el usuario especificó un mes (o mesStr) que tiene débitos directos:
        if (mesParam && mesesConDebitos.includes(mesParam)) {
            filtroActivo = mesParam;
        } else if (mesStr && mesesConDebitos.includes(mesStr)) {
            filtroActivo = mesStr;
        } else if (mesStr) {
            // Si el mes seleccionado (ej: 2026-08) no tiene débitos directos, revisamos si tiene absorción FIFO
            const mInfo = detalleMeses.find(d => d.mes === mesStr);
            if (mInfo && mInfo.consumidoFIFO > 0) {
                filtroActivo = mesStr;
            } else {
                filtroActivo = debitosVigentes.length > 0 ? 'vigente' : (mesesConDebitos[0] || 'todos');
            }
        }

        window._renderizarTablaReporte = function(modo) {
            filtroActivo = modo;
            
            // Actualizar botones tab
            const tabsHtml = `
                <button class="btn btn-sm ${filtroActivo==='vigente'?'btn-primary':'btn-outline'}" onclick="window._renderizarTablaReporte('vigente')" style="font-size:0.68rem;padding:3px 8px;border-radius:5px">
                    🌟 Ventana Vigente ($${totalVigente.toLocaleString('es-MX',{minimumFractionDigits:2})})
                </button>
                ${detalleMeses.map(d => {
                    const cnt = todosDebitos.filter(r => r.mes === d.mes).length;
                    const suma = todosDebitos.filter(r => r.mes === d.mes).reduce((s,r)=>s+parseFloat(r.monto||0),0);
                    const esActivo = filtroActivo === d.mes;
                    const lbl = suma > 0 ? `($${suma.toLocaleString('es-MX',{maximumFractionDigits:0})})` : (d.consumidoFIFO > 0 ? `(FIFO: -$${d.consumidoFIFO.toLocaleString('es-MX',{maximumFractionDigits:0})})` : '($0)');
                    return `
                    <button class="btn btn-sm ${esActivo?'btn-primary':'btn-outline'}" onclick="window._renderizarTablaReporte('${d.mes}')" style="font-size:0.68rem;padding:3px 8px;border-radius:5px">
                        ${d.mes} ${lbl}
                    </button>`;
                }).join('')}
                <button class="btn btn-sm ${filtroActivo==='todos'?'btn-primary':'btn-outline'}" onclick="window._renderizarTablaReporte('todos')" style="font-size:0.68rem;padding:3px 8px;border-radius:5px">
                    Historial Completo (${todosDebitos.length})
                </button>
            `;
            divTabs.innerHTML = tabsHtml;

            // Filtrar transacciones
            let listaFiltrada = [];
            let tituloFiltro = '';
            const bannerFifo = document.getElementById('rep-banner-fifo');

            if (filtroActivo === 'vigente') {
                listaFiltrada = debitosVigentes;
                tituloFiltro = `VENTANA VIGENTE (${mesesVigentes.join(', ')})`;
                bannerFifo.style.display = 'none';
            } else if (filtroActivo === 'todos') {
                listaFiltrada = todosDebitos;
                tituloFiltro = 'HISTORIAL COMPLETO DE DÉBITOS';
                bannerFifo.style.display = 'none';
            } else {
                listaFiltrada = todosDebitos.filter(r => r.mes === filtroActivo);
                tituloFiltro = `MES CONTABLE ${filtroActivo}`;
                
                // Si el mes no tiene movimientos directos pero tiene absorción FIFO (ej: 2026-08)
                const mInfo = detalleMeses.find(d => d.mes === filtroActivo);
                if (listaFiltrada.length === 0 && mInfo && mInfo.consumidoFIFO > 0) {
                    bannerFifo.style.display = 'block';
                    bannerFifo.innerHTML = `
                        <div style="background:linear-gradient(135deg,rgba(99,102,241,0.14),rgba(59,130,246,0.08));border:1px solid rgba(99,102,241,0.35);border-radius:10px;padding:14px 18px;font-size:0.78rem;color:#e0e7ff;">
                            <div style="display:flex;align-items:center;gap:8px;font-weight:700;color:#a5b4fc;margin-bottom:6px">
                                <span style="font-size:1.15rem">💡</span> Descuento de $${mInfo.consumidoFIFO.toLocaleString('es-MX',{minimumFractionDigits:2})} en ${filtroActivo} por Absorción FIFO
                            </div>
                            <div style="color:var(--text-dim);font-size:0.75rem;line-height:1.5">
                                En <strong>${filtroActivo}</strong> el socio no realizó retiros en Centro ni compras directas de tienda ($0 directos).<br>
                                Los <strong>$${mInfo.consumidoFIFO.toLocaleString('es-MX',{minimumFractionDigits:2})}</strong> reflejados en la Auditoría Mensual corresponden al <strong>excedente de gastos acumulados en meses previos de la ventana vigente</strong>, los cuales sumaron <strong>$${totalVigente.toLocaleString('es-MX',{minimumFractionDigits:2})}</strong> y superaron lo generado en esos periodos.<br>
                                Por regla FIFO, ese excedente se absorbió de los <strong>$${(mInfo.generado||0).toLocaleString('es-MX',{minimumFractionDigits:2})}</strong> generados en ${filtroActivo}, dejando un saldo disponible en billetera de <strong style="color:#fcd34d">$${(globalLedger.saldoDisponible).toLocaleString('es-MX',{minimumFractionDigits:2})} MXN</strong>.
                            </div>
                            <div style="margin-top:10px">
                                <button class="btn btn-sm btn-primary" style="font-size:0.72rem;padding:4px 12px;border-radius:4px" onclick="window._renderizarTablaReporte('vigente')">
                                    👉 Ver los ${debitosVigentes.length} consumos de la Ventana Vigente ($${totalVigente.toLocaleString('es-MX',{minimumFractionDigits:2})})
                                </button>
                            </div>
                        </div>
                    `;
                } else {
                    bannerFifo.style.display = 'none';
                }
            }

            // Renderizar tabla
            const tVentas = document.getElementById('rep-ventas-content');
            if (listaFiltrada.length === 0) {
                tVentas.innerHTML = `
                    <tr><td colspan="6" style="text-align:center;padding:26px;color:var(--text-dim)">
                        No hay movimientos de débito directos registrados en <strong>${filtroActivo}</strong>.
                    </td></tr>`;
            } else {
                let totalMonto = 0;
                tVentas.innerHTML = listaFiltrada.map((r, idx) => {
                    totalMonto += parseFloat(r.monto || 0);
                    const bgColor = idx % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'rgba(255,255,255,0.05)';
                    const descLower = (r.descripcion || '').toLowerCase();
                    const esCobroCentro = descLower.includes('cobro activos') || descLower.includes('cobro comisiones');
                    const esTercero = (r.descripcion || '').includes('TERCERO');
                    
                    let tipoBadge = '';
                    let beneficiarioTxt = '';
                    let notaTxt = '';
                    
                    if (esCobroCentro) {
                        tipoBadge = `<span style="display:inline-block;padding:2px 7px;border-radius:4px;font-size:0.67rem;font-weight:700;background:rgba(139,92,246,0.15);color:#c084fc;border:1px solid rgba(139,92,246,0.3)">🏢 COBRO CENTRO</span>`;
                        beneficiarioTxt = `<span style="color:#e0e7ff;font-weight:600">${u.nombre||''}</span> <span style="font-size:0.68rem;color:var(--text-dim)">(#${liderReg})</span>`;
                        notaTxt = `<span style="color:var(--text-dim);font-size:0.75rem">Retiro Comisiones</span>`;
                    } else if (esTercero) {
                        const mCl = (r.descripcion||'').match(/para #(\d+)/);
                        const clNum = mCl ? mCl[1] : '';
                        const clNombre = clNum ? (nombreMap[clNum] || '—') : '—';
                        tipoBadge = `<span style="display:inline-block;padding:2px 7px;border-radius:4px;font-size:0.67rem;font-weight:700;background:rgba(59,130,246,0.15);color:#60a5fa;border:1px solid rgba(59,130,246,0.3)">🛒 TIENDA (RED)</span>`;
                        beneficiarioTxt = `<span style="color:#e0e7ff;font-weight:600">#${clNum}</span> <span style="font-size:0.72rem;color:#cbd5e1">${clNombre}</span>`;
                        const mNota = (r.descripcion||'').match(/Nota\s+([A-Z0-9]+)/i);
                        const nFolio = mNota ? mNota[1].substring(0,8) : (r.venta_id ? String(r.venta_id).substring(0,8) : `TX-${r.id}`);
                        notaTxt = `<span style="color:#3B82F6;cursor:pointer;text-decoration:underline;font-weight:600" onclick="window._abrirNotaReporte('${nFolio}')">${nFolio}</span>`;
                    } else {
                        tipoBadge = `<span style="display:inline-block;padding:2px 7px;border-radius:4px;font-size:0.67rem;font-weight:700;background:rgba(34,197,94,0.15);color:#4ade80;border:1px solid rgba(34,197,94,0.3)">🛒 TIENDA (PROPIO)</span>`;
                        beneficiarioTxt = `<span style="color:#a7f3d0;font-weight:600">Compra Propia</span>`;
                        const mNota = (r.descripcion||'').match(/Nota\s+([A-Z0-9]+)/i);
                        const nFolio = mNota ? mNota[1].substring(0,8) : (r.venta_id ? String(r.venta_id).substring(0,8) : `TX-${r.id}`);
                        notaTxt = `<span style="color:#3B82F6;cursor:pointer;text-decoration:underline;font-weight:600" onclick="window._abrirNotaReporte('${nFolio}')">${nFolio}</span>`;
                    }

                    return `
                    <tr style="background:${bgColor};transition:background 0.15s" onmouseover="this.style.background='rgba(99,102,241,0.08)'" onmouseout="this.style.background='${bgColor}'">
                        <td style="padding:8px 10px;border-bottom:1px solid rgba(255,255,255,0.04);white-space:nowrap;font-size:0.75rem">${(r.fecha||'').substring(0,10)}</td>
                        <td style="padding:8px 10px;border-bottom:1px solid rgba(255,255,255,0.04);text-align:center"><span style="background:rgba(255,255,255,0.06);color:#cbd5e1;padding:1px 6px;border-radius:4px;font-family:monospace;font-size:0.68rem">${r.mes}</span></td>
                        <td style="padding:8px 10px;border-bottom:1px solid rgba(255,255,255,0.04);text-align:center">${tipoBadge}</td>
                        <td style="padding:8px 10px;border-bottom:1px solid rgba(255,255,255,0.04)">${beneficiarioTxt}</td>
                        <td style="padding:8px 10px;border-bottom:1px solid rgba(255,255,255,0.04)">${notaTxt}</td>
                        <td style="padding:8px 10px;border-bottom:1px solid rgba(255,255,255,0.04);text-align:right;color:#ef4444;font-weight:700;white-space:nowrap">-$${parseFloat(r.monto||0).toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
                    </tr>`;
                }).join('') + `
                <tr style="background:rgba(239,68,68,0.08);border-top:2px solid rgba(239,68,68,0.3)">
                    <td colspan="5" style="padding:10px;color:#fff;font-weight:700;font-size:0.8rem">TOTAL CONSUMIDO EN ${tituloFiltro} (${listaFiltrada.length} movimientos)</td>
                    <td style="padding:10px;text-align:right;color:#ef4444;font-weight:700;font-size:0.88rem;white-space:nowrap">-$${totalMonto.toLocaleString('es-MX',{minimumFractionDigits:2})}</td>
                </tr>`;
            }
        };

        // Helper para abrir notas
        window._abrirNotaReporte = async function(folio) {
            try {
                const sql = `SELECT id FROM venta WHERE id::text ILIKE '${folio}%' LIMIT 1`;
                const r = await BO_API.post('/bo/sql-relay', { secret: 'duletia_relay_2026', sql });
                const idVenta = r?.rows?.[0]?.id;
                if (idVenta && typeof verNotaBorrador === 'function') {
                    verNotaBorrador(idVenta);
                } else {
                    BO_AUTH.showAlert('Nota ' + folio, 'info');
                }
            } catch(e) {
                console.warn('error abriendo nota:', e);
            }
        };

        // Render inicial
        window._renderizarTablaReporte(filtroActivo);

    } catch(e) {
        console.error('Error cargando reporte activos:', e);
        document.getElementById('rep-ventas-content').innerHTML = '<tr><td colspan="6" style="text-align:center;padding:20px;color:#ef4444">❌ Error al cargar datos: ' + (e.message||'') + '</td></tr>';
        document.getElementById('rep-ajustes-content').innerHTML = '<span style="color:#ef4444">❌ Error al cargar datos.</span>';
    }
}

/* ============================================================
   PDF GENERATION MODULE
   Uses jsPDF (loaded from CDN)
   ============================================================ */

// ============================================================
// ⏰ BANDERÍN DE CIERRE OPERATIVO & CORTE DE ACTIVOS
// ============================================================
let _relojCierreInterval = null;

function calcularQuintoDiaHabil(anio, mes0Indexed) {
    let habiles = 0;
    let dia = 1;
    let fechaRes = new Date(anio, mes0Indexed, 1);
    while (habiles < 5) {
        fechaRes = new Date(anio, mes0Indexed, dia);
        const dayOfWeek = fechaRes.getDay(); // 0 = Dom, 6 = Sab
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
            habiles++;
        }
        if (habiles < 5) dia++;
    }
    return new Date(anio, mes0Indexed, dia, 23, 59, 59);
}

async function renderBanderinCierreActivos() {
    const bannerEl = document.getElementById('banderinCierreActivos');
    if (!bannerEl) return;

    const tieneRolInterno = (typeof isAdminOrMaster === 'function' && isAdminOrMaster()) || (typeof BO_AUTH !== 'undefined' && BO_AUTH.hasRole && BO_AUTH.hasRole('operativo'));
    if (!tieneRolInterno) {
        bannerEl.style.display = 'none';
        return;
    }

    bannerEl.style.display = 'block';

    const ahora = new Date();
    const anioActual = ahora.getFullYear();
    const mesActual0 = ahora.getMonth();
    const dAnt = new Date(anioActual, mesActual0 - 1, 1);
    const mesAnteriorStr = dAnt.getFullYear() + '-' + String(dAnt.getMonth() + 1).padStart(2, '0');
    
    const mesesNombres = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
    const diasNombres = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
    const nombreMesAnterior = mesesNombres[dAnt.getMonth()];
    const anioMesAnterior = dAnt.getFullYear();

    const fechaCorte = calcularQuintoDiaHabil(anioActual, mesActual0);
    const diaCorteNombre = diasNombres[fechaCorte.getDay()];
    const diaCorteNum = fechaCorte.getDate();
    const nombreMesActual = mesesNombres[mesActual0];

    let configCierre = { ultimo_mes_liberado: '2026-07', modo: 'conciliacion' };
    try {
        const rCfg = await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: "SELECT valor FROM sistema_config WHERE clave = 'cierre_activos_config' LIMIT 1"
        });
        if (rCfg.rows?.[0]?.valor) {
            configCierre = typeof rCfg.rows[0].valor === 'string' ? JSON.parse(rCfg.rows[0].valor) : rCfg.rows[0].valor;
        }
    } catch(e) {}
    window._cierreActivosConfig = configCierre;
    try { localStorage.setItem('dulet_cierre_activos_cfg', JSON.stringify(configCierre)); } catch {}

    const estaLiberado = (configCierre.ultimo_mes_liberado >= mesAnteriorStr && configCierre.modo === 'liberado');
    const esMaster = typeof BO_AUTH !== 'undefined' && BO_AUTH.hasRole && BO_AUTH.hasRole('master');

    if (_relojCierreInterval) {
        clearInterval(_relojCierreInterval);
        _relojCierreInterval = null;
    }

    if (estaLiberado) {
        bannerEl.innerHTML = `
            <div style="background:rgba(34,197,94,0.08);border:1px solid rgba(34,197,94,0.3);border-radius:var(--radius-md);padding:1rem 1.5rem;display:flex;align-items:center;gap:1.25rem;flex-wrap:wrap;">
                <span style="font-size:1.6rem;">✅</span>
                <div style="flex:1;min-width:250px;">
                    <div style="font-weight:700;color:var(--success);font-size:1rem;">Activos & Ventas — ${nombreMesAnterior} ${anioMesAnterior} Liberados Exitosamente</div>
                    <div style="font-size:.82rem;color:var(--text-muted);margin-top:2px;">Periodo formalmente conciliado y definitivo. Los saldos generados están disponibles en la billetera de los líderes.</div>
                </div>
                <div style="display:flex;align-items:center;gap:.75rem;flex-wrap:wrap;">
                    <span style="font-size:0.9rem;font-weight:800;color:var(--success);background:rgba(34,197,94,0.15);border:1px solid rgba(34,197,94,0.3);padding:6px 14px;border-radius:6px;letter-spacing:0.5px;">🟢 CICLO AL DÍA</span>
                    ${esMaster ? `
                        <button class="btn btn-sm" onclick="abrirModalBloquearActivos()" style="background:rgba(239,68,68,0.12);border:1px solid rgba(239,68,68,0.4);color:#f87171;font-weight:700;padding:.5rem .9rem;border-radius:6px;cursor:pointer;">
                            🔒 Volver a Bloquear Periodo
                        </button>
                    ` : ''}
                </div>
            </div>
        `;
    } else {
        window._banderinMesAnteriorStr = mesAnteriorStr;
        window._banderinNombreMesAnterior = `${nombreMesAnterior} ${anioMesAnterior}`;
        
        bannerEl.innerHTML = `
            <div style="background:var(--warning-bg);border:1px solid rgba(245,158,11,.3);border-radius:var(--radius-md);padding:1rem 1.5rem;display:flex;align-items:center;gap:1.25rem;flex-wrap:wrap;">
                <span style="font-size:1.6rem;">⏰</span>
                <div style="flex:1;min-width:260px;">
                    <div style="font-weight:700;color:var(--warning);font-size:1rem;">Cierre de Activos & Ventas — ${nombreMesAnterior} ${anioMesAnterior} en Periodo de Conciliación</div>
                    <div style="font-size:.82rem;color:var(--text-muted);margin-top:2px;">Captura y revisión de notas abierta. Fecha límite de corte: 5to día hábil (${diaCorteNombre} ${diaCorteNum} de ${nombreMesActual} 23:59).</div>
                </div>
                <div style="display:flex;align-items:center;gap:1.25rem;flex-wrap:wrap;">
                    <div style="text-align:right;">
                        <div style="font-size:.68rem;color:var(--text-dim);text-transform:uppercase;font-weight:700;letter-spacing:0.5px;">Tiempo para Cierre</div>
                        <div style="font-size:1.4rem;font-weight:800;color:var(--warning);font-family:monospace;" id="relojCierreActivos">--d --h --m</div>
                    </div>
                    ${esMaster ? `
                        <button class="btn btn-warning btn-sm" onclick="abrirModalLiberarActivos()" style="font-weight:700;white-space:nowrap;padding:.55rem 1rem;box-shadow:0 2px 8px rgba(245,158,11,.2);">
                            🚀 Liberar Activos Anticipadamente
                        </button>
                    ` : ''}
                </div>
            </div>
        `;

        function actualizarReloj() {
            const elReloj = document.getElementById('relojCierreActivos');
            if (!elReloj) return;
            const diff = fechaCorte.getTime() - Date.now();
            if (diff <= 0) {
                elReloj.textContent = '🔒 CORTE VENCIDO';
                elReloj.style.fontSize = '1rem';
                elReloj.style.color = 'var(--danger)';
                return;
            }
            const d = Math.floor(diff / 86400000);
            const h = Math.floor((diff % 86400000) / 3600000);
            const m = Math.floor((diff % 3600000) / 60000);
            const s = Math.floor((diff % 60000) / 1000);
            elReloj.textContent = `${d}d ${String(h).padStart(2,'0')}h ${String(m).padStart(2,'0')}m ${String(s).padStart(2,'0')}s`;
        }

        actualizarReloj();
        _relojCierreInterval = setInterval(actualizarReloj, 1000);
    }
}

function abrirModalLiberarActivos() {
    const mesNom = window._banderinNombreMesAnterior || 'Agosto 2026';
    const titEl = document.getElementById('modalLiberarTitulo');
    const detEl = document.getElementById('modalLiberarDetalle');
    if (titEl) titEl.textContent = `¿Deseas liberar anticipadamente los activos de ${mesNom}?`;
    if (detEl) detEl.textContent = `Al confirmar, las comisiones y activos generados en ${mesNom} quedarán formalmente aprobados y disponibles en la billetera de todos los líderes de la red sin esperar al 5to día hábil.`;
    
    const m = document.getElementById('modalLiberarActivos');
    if (m) m.style.display = 'flex';
}

async function confirmarLiberarActivos() {
    const mesAnt = window._banderinMesAnteriorStr || '2026-08';
    const btn = document.getElementById('btnConfirmarLiberacion');
    if (btn) { btn.disabled = true; btn.textContent = 'Liberando...'; }

    try {
        const user = (typeof CURRENT_USER !== 'undefined' && CURRENT_USER) ? (CURRENT_USER.nombre + ' ' + (CURRENT_USER.apellido || CURRENT_USER.ape_p || '')).trim() : 'Master';
        const userEsc = user.replace(/'/g, "''");

        await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `INSERT INTO sistema_config (clave, valor, updated_by, updated_at)
                  VALUES ('cierre_activos_config', jsonb_build_object('ultimo_mes_liberado', '${mesAnt}', 'modo', 'liberado', 'fecha_liberacion', NOW()), '${userEsc}', NOW())
                  ON CONFLICT (clave) DO UPDATE 
                  SET valor = jsonb_build_object('ultimo_mes_liberado', '${mesAnt}', 'modo', 'liberado', 'fecha_liberacion', NOW()),
                      updated_by = '${userEsc}',
                      updated_at = NOW();`
        });

        BO_AUTH.showAlert(`✅ ¡Activos de ${window._banderinNombreMesAnterior || mesAnt} liberados exitosamente!`, 'success');
        const m = document.getElementById('modalLiberarActivos');
        if (m) m.style.display = 'none';

        await renderBanderinCierreActivos();
        if (typeof loadActivos === 'function') await loadActivos();
    } catch(e) {
        BO_AUTH.showAlert('Error al liberar activos: ' + e.message, 'danger');
    } finally {
        if (btn) { btn.disabled = false; btn.textContent = '✅ Confirmar Liberación'; }
    }
}

function abrirModalBloquearActivos() {
    const esMaster = typeof BO_AUTH !== 'undefined' && BO_AUTH.hasRole && BO_AUTH.hasRole('master');
    if (!esMaster) {
        return BO_AUTH.showAlert('⛔ Solo el usuario con Rol Master puede bloquear o revertir periodos.', 'danger');
    }
    const mesNom = window._banderinNombreMesAnterior || 'Agosto 2026';
    const modalId = 'modalBloquearActivos';
    if (document.getElementById(modalId)) document.getElementById(modalId).remove();
    const modal = document.createElement('div');
    modal.id = modalId;
    modal.innerHTML = `
        <div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.85);z-index:99999;display:flex;align-items:center;justify-content:center;backdrop-filter:blur(6px);">
            <div style="background:#13151b;border:1px solid rgba(239,68,68,0.3);border-radius:18px;padding:24px;max-width:500px;width:92%;box-shadow:0 24px 48px rgba(0,0,0,0.8);">
                <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;">
                    <span style="font-size:1.15rem;font-weight:700;color:#f87171;display:flex;align-items:center;gap:8px;">
                        <span>🔒</span> Volver a Bloquear Periodo
                    </span>
                    <button class="btn btn-sm btn-outline" onclick="document.getElementById('${modalId}').remove()" style="padding:2px 8px;border-radius:6px;">✕</button>
                </div>
                <div style="background:rgba(239,68,68,0.1);border:1px solid rgba(239,68,68,0.3);border-radius:10px;padding:14px;margin-bottom:16px;">
                    <strong style="color:#f87171;font-size:0.9rem;display:block;margin-bottom:6px;">¿Deseas revertir la liberación de ${mesNom}?</strong>
                    <p style="margin:0;font-size:0.8rem;color:var(--text-muted);line-height:1.4;">
                        El periodo regresará al estatus de <strong>Conciliación</strong>. Los saldos generados en ${mesNom} volverán a quedar <strong>bloqueados</strong> (pendientes de liberación) para todos los líderes de la red hasta el 5to día hábil o hasta que vuelvas a liberar.
                    </p>
                </div>
                <div style="margin-bottom:16px;">
                    <label style="display:block;font-size:0.75rem;color:#f87171;font-weight:700;margin-bottom:6px;">Contraseña / PIN Master para Revertir:</label>
                    <input type="password" id="bloquearActivosPin" class="form-control" style="width:100%;background:rgba(0,0,0,0.35);border:1px solid rgba(239,68,68,0.4);color:#fff;border-radius:8px;padding:8px 12px;font-size:0.9rem;" placeholder="Introduce la clave de autorización Master">
                </div>
                <div style="display:flex;justify-content:flex-end;gap:10px;">
                    <button class="btn btn-outline btn-sm" onclick="document.getElementById('${modalId}').remove()">Cancelar</button>
                    <button class="btn btn-danger btn-sm" id="btnConfirmarBloqueo" onclick="confirmarBloquearActivos()" style="background:#ef4444;color:#fff;font-weight:700;border:none;padding:7px 16px;border-radius:8px;cursor:pointer;">🔒 Confirmar Bloqueo</button>
                </div>
            </div>
        </div>
    `;
    document.body.appendChild(modal);
}

async function confirmarBloquearActivos() {
    const pin = document.getElementById('bloquearActivosPin')?.value.trim();
    if (pin !== 'pitomaestro') {
        return BO_AUTH.showAlert('⛔ PIN o Contraseña Master incorrecta. No se revirtió el periodo.', 'danger');
    }

    const btn = document.getElementById('btnConfirmarBloqueo');
    if (btn) { btn.disabled = true; btn.textContent = 'Bloqueando...'; }

    try {
        const user = (typeof CURRENT_USER !== 'undefined' && CURRENT_USER) ? (CURRENT_USER.nombre + ' ' + (CURRENT_USER.apellido || CURRENT_USER.ape_p || '')).trim() : 'Master';
        const userEsc = user.replace(/'/g, "''");

        await BO_API.post('/bo/sql-relay', {
            secret: 'duletia_relay_2026',
            sql: `INSERT INTO sistema_config (clave, valor, updated_by, updated_at)
                  VALUES ('cierre_activos_config', jsonb_build_object('ultimo_mes_liberado', '2026-07', 'modo', 'conciliacion', 'fecha_bloqueo', NOW()), '${userEsc}', NOW())
                  ON CONFLICT (clave) DO UPDATE 
                  SET valor = jsonb_build_object('ultimo_mes_liberado', '2026-07', 'modo', 'conciliacion', 'fecha_bloqueo', NOW()),
                      updated_by = '${userEsc}',
                      updated_at = NOW();`
        });

        window._cierreActivosConfig = { ultimo_mes_liberado: '2026-07', modo: 'conciliacion' };
        try { localStorage.setItem('dulet_cierre_activos_cfg', JSON.stringify(window._cierreActivosConfig)); } catch {}

        BO_AUTH.showAlert('🔒 ¡Periodo revertido a conciliación con éxito! Los activos vuelven a estar bloqueados.', 'success');
        const m = document.getElementById('modalBloquearActivos');
        if (m) m.remove();

        await renderBanderinCierreActivos();
        if (typeof loadActivos === 'function') await loadActivos();
    } catch(e) {
        BO_AUTH.showAlert('Error al bloquear activos: ' + e.message, 'danger');
    } finally {
        if (btn) { btn.disabled = false; btn.textContent = '🔒 Confirmar Bloqueo'; }
    }
}

window.renderBanderinCierreActivos = renderBanderinCierreActivos;
window.abrirModalLiberarActivos = abrirModalLiberarActivos;
window.confirmarLiberarActivos = confirmarLiberarActivos;
window.abrirModalBloquearActivos = abrirModalBloquearActivos;
window.confirmarBloquearActivos = confirmarBloquearActivos;


